import Contract from 'web3-eth-contract'
import onion1 from '../abi/onionAuction.json'
import sell1 from '../abi/sell.json'
import erc11551 from '../abi/erc1155.json'
import erc201 from '../abi/exs.json'
import utils from './utils'
import Web3 from 'web3'
import { ethers } from 'ethers'
import axios from 'axios'
import BigNumber from 'bignumber.js'
import { buyNfts } from '../../components/buyScreen/api'
import { Assets } from '../../web3config/metadata'
import erc1155poly from '../abi/erc1155poly.json'
import onionAuctionPoly from '../abi/onionAuctionpoly.json'
import erc20poly from '../abi/exspoly.json'
import erc20binance from '../abi/USDT_BINANCE.json'
import onionAuctionBinance from '../abi/onionAuction_FirstMarket.json'
import sellBinance from '../abi/sellContract_SecondMarket.json'

// Camel games abis
import CamelGameerc20 from '../abi/camelgameERC20.json'
import CamelGameerc721 from '../abi/camelgameerc721.json'
import alhijan from '../abi/camelgamesAlhijan.json'
import { Callbacks, error } from 'jquery'

const currentNetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'

var erc1155 = null
var onion = null
var erc20 = null
var sell = sell1
var environement = `${process.env.REACT_APP_ENVIRONMENT}`
if (
  (currentNetwork == 'MUMBAI' && environement == 'live') ||
  (currentNetwork == 'MUMBAI' && environement == 'staging')
) {
  erc1155 = erc1155poly
  erc20 = erc20poly
  onion = onionAuctionPoly
  sell = sell1
} else {
  erc1155 = erc11551
  onion =
    currentNetwork == 'BINANCE' && environement == 'live'
      ? onionAuctionBinance
      : onion1
  erc20 =
    currentNetwork == 'BINANCE' && environement == 'live'
      ? erc20binance
      : erc201
  sell =
    currentNetwork == 'BINANCE' && environement == 'live' ? sellBinance : sell1
}

const Auction = {
  contract(Provider, addressContract, abi) {
    const contract = new Contract(abi, addressContract)
    contract.setProvider(Provider.provider)
    return contract
  },
  socketContract(Provider, contractInfo) {
    const contract = new Contract(onion['abi'], contractInfo.address)
    contract.setProvider(Provider.sockets[0])
    return contract
  },

  async buyReward(
    Provider,
    walletType,
    useraccount,
    amount,
    currency,
    request,
    callback
  ) {
    ////console.log(useraccount)
    try {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      const currencies = Assets['polygon'].ERC20
      ////console.log(currencies)
      const adminAccount = process.env.REACT_APP_ADMIN_WALLET_REWARD

      var currentRPC = null
      var currentErc20 = currencies?.filter(
        item => item?.name == currency?.toUpperCase()
      )[0]?.address
      if (currentnetwork == 'MUMBAI') {
        currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
      } else if (currentnetwork == 'BINANCE') {
        currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
      } else {
        currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
      }

      const ERC20ContractMetaMask = await this.providerRPC(
        Provider,
        currentErc20,
        erc20['abi']
      )
      const web3 = new Web3(currentRPC)
      const erc20Contract = new web3.eth.Contract(erc20['abi'], currentErc20)
      const decimals = await erc20Contract?.methods?.decimals().call()
      const newAmount = '1' + '0'?.repeat(decimals)
      const amountToPurchase = (amount * newAmount).toString()
      if (walletType != 'WALLETCONNECT') {
        try {
          ERC20ContractMetaMask?.methods
            ?.transfer(adminAccount, amountToPurchase)
            .send({
              from: useraccount
            })
            .once('receipt', hash => {
              ////console.log(hash)
              callback(null, hash?.transactionHash)
            })
            .on('error', err => {
              ////console.log(err)
              callback(err, null)
            })
        } catch (err) {
          callback(err, null)
        }
      } else {
        try {
          const gasPrice = await web3.eth.getGasPrice()
          const gas = await erc20Contract.methods
            .transfer(adminAccount, amountToPurchase)
            .estimateGas({
              from: useraccount,
              gasPrice: gasPrice
            })
          let extraData = erc20Contract.methods?.transfer(
            adminAccount,
            amountToPurchase
          )
          ////console.log(extraData)
          let data = extraData.encodeABI()
          ////console.log(data)
          request({
            topic: Provider?.topic,
            chainId: 'eip155:1',
            request: {
              id: 1,
              jsonrpc: '2.0',
              method: 'eth_signTransaction',
              params: [
                {
                  to: currentErc20,
                  data: data,
                  gasPrice: web3.utils.toHex(gasPrice),
                  gasLimit: web3.utils.toHex(gas),
                  amount: parseFloat(amount).toFixed(4),
                  symbol: 'USDT'
                }
              ]
            }
          })
            .then(data => {
              web3.eth
                .sendSignedTransaction(data)
                .then(async response => {
                  //console.log(response)
                  callback(null, response?.transactionHash)
                })
                .catch(error => {
                  //console.log(error)
                  callback(error, null)
                })
            })
            .catch(err => {
              callback(error, null)
            })
        } catch (err) {
          callback(err, null)
        }
      }
    } catch (err) { }
  },

  async calculateGasFee(
    usddata,
    cardId,
    account1,
    nftdetail,
    tokens,
    onioncontract,
    setUsd,
    type,
    packAmount,
    cb
  ) {
    //console.log(onioncontract)
    console.log(nftdetail)
    const account =
      nftdetail?.type == 'camel'
        ? process.env.REACT_APP_ADMIN_WALLET_CAMEL
        : process.env.REACT_APP_ADMIN_WALLET

    let data = null
    try {
      data =
        usddata == null
          ? await axios?.get(
            'https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD,EUR'
          )
          : usddata
      //console.log(data)
    } catch (e) {
      console.log(e)
      cb('Network congestion - Please try again at a later time', null)
      return
    }
    var erc20adress = null
    if (data?.data != undefined) {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      var currentRPC = null
      if (currentnetwork == 'MUMBAI') {
        currentRPC = `${process.env.REACT_APP_MUMBAI_RPC}`
      } else if (currentnetwork == 'BINANCE') {
        currentRPC = `${process.env.REACT_APP_BINANCE_RPC}`
      } else {
        currentRPC = `${process.env.REACT_APP_RINKEY_RPC}`
      }
      //console.log(currentRPC)
      const web3 = new Web3(currentRPC)
      let erc20ContractAddress = null
      if (
        localStorage.getItem('currentNetwork') == undefined ||
        localStorage.getItem('currentNetwork') == 'MUMBAI'
      ) {
        erc20ContractAddress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_MUMBAI_ER20}`
            : `${process.env.REACT_APP_USDT_POLY}`
        erc20adress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
            : `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
      } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
        erc20ContractAddress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_BINANCE_ER20}`
            : `${process.env.REACT_APP_USDT_BNB}`
        erc20adress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
            : `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
      } else {
        erc20ContractAddress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_RINKEY_ER20}`
            : `${process.env.REACT_APP_USDT_ETH}`
        erc20adress =
          nftdetail?.currency == 'EXS'
            ? `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
            : `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
      }
      //console.log(erc20ContractAddress)
      let onionContractAddress = null
      var alhijanadress = null
      var erc721adress = null
      if (nftdetail?.onSell == true) {
        if (
          localStorage.getItem('currentNetwork') == undefined ||
          localStorage.getItem('currentNetwork') == 'MUMBAI'
        ) {
          onionContractAddress = `${process.env.REACT_APP_SELLING_POLY}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
          onionContractAddress = `${process.env.REACT_APP_SELLING_BNB}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        } else {
          onionContractAddress = `${process.env.REACT_APP_SELLING_ETH}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        }
      } else {
        if (
          localStorage.getItem('currentNetwork') == undefined ||
          localStorage.getItem('currentNetwork') == 'MUMBAI'
        ) {
          onionContractAddress = `${process.env.REACT_APP_MUMBAI_ONION}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
          onionContractAddress = `${process.env.REACT_APP_BINANCE_ONION}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        } else {
          onionContractAddress = `${process.env.REACT_APP_RINKEY_ONION}`
          alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
          erc721adress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        }
      }

      //console.log(onionContractAddress)
      const erc20Contract =
        nftdetail?.type == 'camel'
          ? new web3.eth.Contract(CamelGameerc20['abi'], erc20adress)
          : new web3.eth.Contract(erc20['abi'], erc20ContractAddress)
      console.log(erc20Contract)
      const contractAuction =
        nftdetail?.type == 'camel'
          ? new web3.eth.Contract(alhijan['abi'], alhijanadress)
          : new web3.eth.Contract(onion['abi'], onionContractAddress)
      console.log(contractAuction)
      const erc721Contract = new web3.eth.Contract(
        CamelGameerc721['abi'],
        erc721adress
      )
      const camlContractAuction = new web3.eth.Contract(
        CamelGameerc721['abi'],
        erc721adress
      )
      console.log(camlContractAuction)
      var token = tokens.find(x => x.name == nftdetail.currency.toUpperCase())
      var decimals = tokens.find(
        x => x.name == nftdetail?.currency.toUpperCase()
      )?.decimals
      var amount = this.fromDecimals(
        parseFloat(nftdetail?.pricePerCard).toFixed(2),
        token
      )
      if (type == 'pack') {
        try {
          let packPrice = await erc721Contract?.methods.price().call()

          packPrice = (Number(packPrice) * Number(packAmount)).toString()
          // packPrice = `${20}`
          console.log(packPrice)

          const decimal = await erc20Contract.methods.decimals().call()
          let price = null
          price = (
            Number(packPrice) / Number(`1` + '0'.repeat(decimal))
          ).toString()
          const gasPrice = await web3.eth.getGasPrice()
          const gasLimitApprove = await erc20Contract.methods
            .approve(erc721adress, packPrice)
            .estimateGas({ from: account, gasPrice: gasPrice })
          const gasPriceApprove = await web3.eth.getGasPrice()
          const txPriceWeiApprove = gasLimitApprove * gasPriceApprove
          const txPriceEthApprove = await web3.utils.fromWei(
            txPriceWeiApprove.toString(),
            'ether'
          )
          const txPriceUSDApprove = txPriceEthApprove * data?.data.USD
          console.log('Approve Estimated price : ', txPriceUSDApprove)

          // const gasPriceBuy = await web3.eth.getGasPrice()
          const gasLimitBuy = await camlContractAuction?.methods
            ?.adminMint(packAmount, account1)
            .estimateGas({ from: account, gasPrice: gasPrice })
          const txPriceWeiBuy = gasLimitBuy * gasPriceApprove
          const txPriceEthBuy = await web3.utils.fromWei(
            txPriceWeiBuy.toString(),
            'ether'
          )
          const txPriceUSDBuy = txPriceEthBuy * data?.data.USD
          //console.log('Buy Estimate price ', txPriceUSDBuy)

          let totalGas = txPriceUSDBuy + txPriceUSDApprove

          setUsd(data)

          cb(null, totalGas)
        } catch (e) {
          console.log(e)
          cb('Network congestion - Please try again at a later time', null)
        }
      } else {
        //console.log(amount)
        try {
          const gasPriceApprove = await web3.eth.getGasPrice()
          const gasLimitApprove =
            nftdetail?.type == 'camel'
              ? await erc20Contract.methods
                .approve(
                  alhijanadress,
                  nftdetail?.extradetails?.pricePerCamel
                )
                .estimateGas({
                  from: account,
                  gasPrice: web3.utils.toHex(gasPriceApprove)
                })
              : await erc20Contract.methods
                .approve(onionContractAddress, amount)
                .estimateGas({
                  from: account,
                  gasPrice: web3.utils.toHex(gasPriceApprove)
                })

          console.log('Gas limit Aprrove' + gasLimitApprove)
          const txPriceWeiApprove = gasLimitApprove * gasPriceApprove
          const txPriceEthApprove = await web3.utils.fromWei(
            txPriceWeiApprove.toString(),
            'ether'
          )
          const txPriceUSDApprove = txPriceEthApprove * data?.data.USD
          console.log('Approve Estimated price : ', txPriceUSDApprove)

          // const gasPriceBuy = await web3.eth.getGasPrice()
          const gasLimitBuy =
            nftdetail?.type == 'camel'
              ? await contractAuction?.methods
                ?.buyCamel(nftdetail?.onionId, account)
                .estimateGas({
                  from: account,
                  gasPrice: web3.utils.toHex(gasPriceApprove)
                })
              : await contractAuction.methods
                .buyCard(cardId, account1)
                .estimateGas({
                  from: account,
                  gasPrice: web3.utils.toHex(gasPriceApprove)
                })
          const txPriceWeiBuy = gasLimitBuy * gasPriceApprove
          const txPriceEthBuy = await web3.utils.fromWei(
            txPriceWeiBuy.toString(),
            'ether'
          )
          const txPriceUSDBuy = txPriceEthBuy * data?.data.USD
          //console.log('Buy Estimate price ', txPriceUSDBuy)

          let totalGas = txPriceUSDBuy + txPriceUSDApprove

          setUsd(data)

          cb(null, totalGas)
        } catch (e) {
          console.log(e)
          cb('Network congestion - Please try again at a later time', null)
        }
      }
    } else {
      cb('something went Wrong', null)
    }
  },
  async createProvider() {
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    var currentNetworkAddress = null
    var currentRPC = null
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
      currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
      currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
      currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
    }

    return { currentNetworkAddress, currentRPC }
  },
  async getAlhijannfts(adress) {
    //console.log(adress)
    try {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      var currentNetworkAddress = null
      var currentRPC = null
      if (currentnetwork == 'MUMBAI') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ERC721_POLY}`
        currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
      } else if (currentnetwork == 'BINANCE') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
      } else {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ERC721_ETH}`
        currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
      }
      const web3 = new Web3(currentRPC)
      const contractAuction = new web3.eth.Contract(
        CamelGameerc721['abi'],
        currentNetworkAddress
      )
      //console.log(contractAuction)
      const transferEvents = await contractAuction.getPastEvents('Transfer', {
        filter: { to: adress },
        fromBlock: 0,
        toBlock: 'latest'
      })

      const ids = []
      transferEvents?.map(item => {
        if (item?.returnValues.to?.toLowerCase() == adress?.toLowerCase()) {
          ids.push(item?.returnValues?.tokenId)
        }
      })
      //console.log(ids)
      return ids
    } catch (err) {
      return err
    }
  },
  async mintCamelNfts(
    Provider1,
    adress,
    wallletType,
    packamount,
    transactiondata,
    token,
    request = {},
    callBack
  ) {
    try {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      var currentNetworkAddress = null
      var currentRPC = null
      var currentErc20 = null
      if (currentnetwork == 'MUMBAI') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
        currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
        currentErc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
      } else if (currentnetwork == 'BINANCE') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
        currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
        currentErc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
      } else {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
        currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
        currentErc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
      }
      const web3 = new Web3(currentRPC)
      const contractAuction = new web3.eth.Contract(
        CamelGameerc721['abi'],
        currentNetworkAddress
      )
      const erc20contract = new web3.eth.Contract(
        CamelGameerc20['abi'],
        currentErc20
      )

      let packPrice = await contractAuction?.methods.price().call()
      console.log(packPrice)

      packPrice = (Number(packPrice) * Number(packamount)).toString()
      // packPrice = `${20}`
      console.log(packPrice)

      if (wallletType == 'WALLETCONNECT') {
        const decimal = await erc20contract.methods.decimals().call()
        let price = null
        price = (
          Number(packPrice) / Number(`1` + '0'.repeat(decimal))
        ).toString()
        const gasPrice = await web3.eth.getGasPrice()
        const gas = await erc20contract.methods
          .approve(currentNetworkAddress, packPrice)
          .estimateGas({ from: adress, gasPrice: gasPrice })
        let extraData = erc20contract.methods.approve(
          currentNetworkAddress,
          packPrice
        )
        //console.log(extraData)
        let data = extraData.encodeABI()
        const dataObj = {
          data: data,
          gasPrice: gasPrice,
          gasLimit: gas,
          amount: parseFloat(price).toFixed(4)
        }
        let parsedata1 = JSON.stringify(dataObj)
        //console.log(data)

        //console.log('I am Here')
        request({
          topic: Provider1?.topic,
          chainId: 'eip155:1',
          request: {
            id: 1,
            jsonrpc: '2.0',
            method: 'eth_signTransaction',
            params: [
              {
                to: currentErc20,
                data: data,
                gasPrice: web3.utils.toHex(gasPrice),
                gasLimit: web3.utils.toHex(gas),
                amount: parseFloat(price).toFixed(4),
                symbol: 'USDT'
              }
            ]
          }
        })
          .then(data => {
            web3.eth
              .sendSignedTransaction(data)
              .once('receipt', async hash => {
                console.log(hash)
                let gasPrice1 = null
                let gas1 = null
                try {
                  gasPrice1 = await web3.eth.getGasPrice()
                  console.log(gasPrice1)
                  console.log(contractAuction)
                  gas1 = await contractAuction?.methods
                    ?.mint(packamount)
                    .estimateGas({ from: adress, gasPrice: gasPrice1 })
                  console.log(gas1)
                } catch (err) {
                  console.log('I am Mint Error')
                  console.log(err)
                }
                let extraData = contractAuction?.methods?.mint(packamount)
                let data = extraData.encodeABI()
                console.log({
                  to: currentNetworkAddress,
                  data: data,
                  gasPrice: web3.utils.toHex(gasPrice1),
                  gasLimit: web3.utils.toHex(gas1),
                  amount: parseFloat(price).toFixed(4),
                  symbol: 'USDT'
                })
                request({
                  topic: Provider1?.topic,
                  chainId: 'eip155:1',
                  request: {
                    id: 1,
                    jsonrpc: '2.0',
                    method: 'eth_signTransaction',
                    params: [
                      {
                        to: currentNetworkAddress,
                        data: data,
                        gasPrice: web3.utils.toHex(gasPrice1),
                        gasLimit: web3.utils.toHex(gas1),
                        amount: parseFloat(price).toFixed(4),
                        symbol: 'USDT'
                      }
                    ]
                  }
                })
                  .then(data => {
                    web3.eth
                      .sendSignedTransaction(data)
                      .on('transactionHash', data => {
                        console.log(data)
                        buyNfts?.buyProduct(
                          {
                            ...transactiondata,
                            transaction: data,
                            status: 2
                          },
                          token,
                          (err, element) => { }
                        )
                      })
                      .once('receipt', hash => {
                        console.log(hash)
                        callBack(null, hash?.transactionHash)
                      })
                      .on('error', err => {
                        console.log(err)
                        callBack(err, null)
                      })
                  })
                  .catch(err => {
                    callBack(err, null)
                  })
              })
              .on('error', err => {
                console.log(err)
                callBack(err, null)
              })
          })
          .catch(err => {
            callBack(err, null)
          })
      } else {
        const contractAuction1 = await this.providerRPC(
          Provider1,

          currentNetworkAddress,
          CamelGameerc721['abi']
        )
        const erc20contract1 = await this.providerRPC(
          Provider1,

          currentErc20,
          CamelGameerc20['abi']
        )
        erc20contract1.methods
          .approve(currentNetworkAddress, packPrice)
          .send({
            from: adress
          })
          .on('receipt', async function (hash) {
            //console.log(hash)
            // //console.log(result1)
            contractAuction1?.methods
              ?.mint(packamount)
              .send({
                from: adress
              })
              .on('transactionHash', data => {
                buyNfts?.buyProduct(
                  {
                    ...transactiondata,
                    transaction: data,
                    status: 2
                  },
                  token,
                  (err, element) => { }
                )
              })
              .on('receipt', async function (hash) {
                callBack(null, hash?.transactionHash)
              })
              .on('error', err => {
                callBack(err, null)
              })
          })
          .on('error', err => {
            callBack(err, null)
          })
      }
    } catch (e) {
      //console.log(e)
      callBack(e, null)
    }
  },
  async getCamelGamesNfts(tokens, callBack) {
    let auctions = []
    try {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      var currentNetworkAddress = null
      var currentRPC = null
      if (currentnetwork == 'MUMBAI') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
        currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
      } else if (currentnetwork == 'BINANCE') {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
        currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
      } else {
        currentNetworkAddress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
        currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
      }
      const web3 = new Web3(currentRPC)
      const camelcontract = new web3.eth.Contract(
        alhijan['abi'],
        currentNetworkAddress
      )
      const allcamelAuction =
        (await camelcontract.methods.getAllCamelAuctionId()?.call()) || []
      console.log("allcamelAuction ======", allcamelAuction)
      const alldata = await camelcontract.methods
        .batchDetailsCamelAuction(allcamelAuction)
        .call()

      console.log(alldata)
      alldata.forEach((auction, index) => {
        let formated = this.formatAuctionDataCamel(auction, tokens)
        //console.log(formated)
        formated.onionId = allcamelAuction[index]
        formated.extradetails = auction
        auctions.push(formated)
      })
      //console.log(camelcontract?.methods)
      console.log(auctions)
      callBack(null, auctions)
    } catch (e) {
      console.log(e)
      callBack(e, null)
    } finally {
      callBack(null, auctions)
    }
  },
  async auctionCamelNft() {
    const { currentNetworkAddress, currentRPC } = this.createProvider()
    const web3 = new Web3(currentRPC)
    const camelcontract = new web3.eth.Contract(
      alhijan['abi'],
      currentNetworkAddress
    )
    const allcamelAuction =
      (await camelcontract.methods.getAllCamelAuctionId()?.call()) || []
    //console.log(allcamelAuction)
    const alldata = await camelcontract.methods
      .batchDetailsCamelAuction(allcamelAuction)
      .call()
  },
  async buyCamelNft(
    Provider,
    wallletType,
    adress,
    nftdata,
    transactiondata,
    token,
    request = {},
    cb
  ) {
    try {
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      var alhijanadress = null
      var currentRPC = null
      var erc20 = null
      if (currentnetwork == 'MUMBAI') {
        alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
        currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
        erc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
      } else if (currentnetwork == 'BINANCE') {
        alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
        currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
        erc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
      } else {
        alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
        currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
        erc20 = `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
      }
      const web3 = new Web3(currentRPC)

      const camelcontract = await this.providerRPC(
        Provider,
        alhijanadress,
        alhijan['abi']
      )
      const erc20contract = await this.providerRPC(
        Provider,
        erc20,
        CamelGameerc20['abi']
      )
      console.log(erc20contract)
      console.log(camelcontract)

      console.log(wallletType)

      console.log(nftdata)
      if (wallletType == 'METAMASK') {
        erc20contract?.methods
          ?.approve(alhijanadress, nftdata?.extradetails?.pricePerCamel)
          .send({
            from: adress
          })
          .once('receipt', hash => {
            console.log(hash)
            camelcontract?.methods
              ?.buyCamel(nftdata?.onionId, adress)
              .send({
                from: adress
              })
              .on('transactionHash', data => {
                buyNfts?.buyProduct(
                  {
                    ...transactiondata,
                    transaction: data,
                    status: 2
                  },
                  token,
                  (err, element) => { }
                )
              })
              .once('receipt', hash => {
                console.log(hash)
                cb(null, hash?.transactionHash)
              })
              .on('error', err => {
                cb(err, null)
              })
          })
          .on('error', err => {
            //console.log(err)
            cb(err, null)
          })
      } else {
        const ERC20Contract = new web3.eth.Contract(
          CamelGameerc20['abi'],
          erc20
        )
        console.log(ERC20Contract)
        const camelContract = new web3.eth.Contract(
          alhijan['abi'],
          alhijanadress
        )
        const gasPrice = await web3.eth.getGasPrice()
        const gas = await ERC20Contract.methods
          .approve(alhijanadress, nftdata?.extradetails?.pricePerCamel)
          .estimateGas({
            from: adress,
            gasPrice: gasPrice
          })
        let extraData = ERC20Contract.methods.approve(
          alhijanadress,
          nftdata?.extradetails?.pricePerCamel
        )
        ////console.log(extraData)
        let data = extraData.encodeABI()
        const dataObj = {
          data: data,
          gasPrice: gasPrice,
          gasLimit: gas,
          amount: nftdata?.pricePerCard.toFixed(2)
        }
        let parsedata1 = JSON.stringify(dataObj)
        ////console.log(data)

        const customRequest = {
          id: 1337,
          jsonrpc: '2.0',
          method: 'bnb_sign',
          params: [
            {
              account_number: '34',
              chain_id: '97',
              data: parsedata1,
              memo: 'test',
              msgs: [
                {
                  inputs: [
                    {
                      address: erc20,
                      coins: [
                        {
                          amount: parseInt(3),
                          denom: 'USDT'
                        }
                      ]
                    }
                  ],
                  outputs: [
                    {
                      address: erc20,
                      coins: [
                        {
                          amount: parseInt(3),
                          denom: 'USDT'
                        }
                      ]
                    }
                  ]
                }
              ],
              sequence: '31',
              source: '1'
            }
          ]
        }

        request({
          topic: Provider?.topic,
          chainId: 'eip155:1',
          request: {
            id: 1,
            jsonrpc: '2.0',
            method: 'eth_signTransaction',
            params: [
              {
                to: erc20,
                data: data,
                gasPrice: web3.utils.toHex(gasPrice),
                gasLimit: web3.utils.toHex(gas),
                amount: parseFloat(nftdata?.pricePerCard).toFixed(2),
                symbol: nftdata.currency
              }
            ]
          }
        })
          .then(data => {
            web3.eth
              .sendSignedTransaction(data)
              .once('receipt', async hash => {
                console.log(hash)
                const gasPrice1 = await web3.eth.getGasPrice()
                const gas = await camelContract?.methods
                  ?.buyCamel(nftdata?.onionId, adress)
                  .estimateGas({
                    from: adress,
                    gasPrice: gasPrice
                  })
                let extraData = camelContract?.methods?.buyCamel(
                  nftdata?.onionId,
                  adress
                )
                let data = extraData.encodeABI()
                request({
                  topic: Provider?.topic,
                  chainId: 'eip155:1',
                  request: {
                    id: 1,
                    jsonrpc: '2.0',
                    method: 'eth_signTransaction',
                    params: [
                      {
                        to: alhijanadress,
                        data: data,
                        gasPrice: web3.utils.toHex(gasPrice1),
                        gasLimit: web3.utils.toHex(gas),
                        amount: parseFloat(nftdata?.pricePerCard).toFixed(2),
                        symbol: nftdata.currency
                      }
                    ]
                  }
                })
                  .then(data => {
                    web3.eth
                      .sendSignedTransaction(data)
                      .on('transactionHash', data => {
                        buyNfts?.buyProduct(
                          {
                            ...transactiondata,
                            transaction: data,
                            status: 2
                          },
                          token,
                          (err, element) => { }
                        )
                      })
                      .once('receipt', hash => {
                        console.log(hash)
                        cb(null, hash?.transactionHash)
                      })
                      .on('error', err => {
                        console.log(err)
                        cb(err, null)
                      })
                  })
                  .catch(err => {
                    cb(err, null)
                  })
              })
              .on('error', err => {
                console.log(err)
                cb(err, null)
              })
          })
          .catch(err => {
            cb(err, null)
          })
      }
    } catch (err) {
      cb(err, null)
    }
  },
  /**
   *
   * @param {Number} value Value Base
   * @param {Object} token token data to obtain decimals
   * @returns {Number} value converted to JS decimals
   */
  // toDecimals(value, token) {
  //   const decimal = Math.pow(10, token.decimals) // {}*10**token.decimals
  //   const total = Number.parseFloat(value / decimal).toFixed(16) //please do not move this, as it maintains floating point precision.
  //   return total
  // },

  toDecimals(value, token) {
    var total = 0
    if (value != null) {
      const decimal = Math.pow(10, token.decimals) // {}*10**token.decimals
      total = Number.parseFloat(Number(value.toString()) / decimal).toFixed(16) //please do not move this, as it maintains floating point precision.
    }
    return total
  },
  /**
   *
   * @param {Number} x Value Base
   * @param {Object} token token data to obtain decimals
   * @returns {Number} X converted to type solidity decimals
   */
  fromDecimals(x, token) {
    if (token.decimals == 18) {
      return utils.toWei(x)
    }
    const xInt = Math.pow(10, token.decimals)
    const xWei = x * xInt
    return xWei
  },

  async providerRPC(Provider, tokenAddress, abi) {
    try {
      const contract = this.contract(Provider, tokenAddress, abi)
      return contract
    } catch (error) {
      //console.log(error)
    }
  },
  /**
   *
   * @param {String} addressContract address of the contract onionAcution
   * @param {Json} abi Interface Solidity Contract
   * @returns {Object} Contract call Object
   */
  mobileProvider(addressContract, abi) {
    const contract = new Contract(abi, addressContract)
    const link =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_MUMBAI_RPC}`
          : localStorage.getItem('currentNetwork') == 'EHETERUM'
            ? `${process.env.REACT_APP_RINKEY_RPC}`
            : `${process.env.REACT_APP_BINANCE_RPC}`
        : `${process.env.REACT_APP_MUMBAI_RPC}`
    //console.log(link)
    contract.setProvider(link)
    return contract
  },

  async getSellAuctiondata(tokens) {
    //console.log(tokens)
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    var currentNetworkAddress = null
    var currentRPC = null
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
    }
    const web3 = new Web3(currentRPC)
    const ERC20Contract = new web3.eth.Contract(
      sell['abi'],
      currentNetworkAddress
    )
    //console.log(ERC20Contract)
    const id = await ERC20Contract.methods.getAllUsersAuctionId().call()
    //console.log(id)
    const data = await ERC20Contract.methods.batchDetailsUserAuction(id).call()
    //console.log(data)
    const actualdata = []
    data.forEach((auction, index) => {
      if (auction['_pricePerCard'] != 0) {
        let formated = this.formatAuctionData(auction, tokens)
        if (Object.keys(formated)?.length > 0) {
          formated.onionId = id[index]
          formated.pricePerCard = parseFloat(formated.pricePerCard)?.toFixed(3)
          formated.extradetails = auction
          actualdata.push(formated)
        }
      } else {
      }
    })
    //console.log(actualdata)
    return actualdata
  },
  async reclaim(Provider, walletType, nft, adress, request, callBack) {
    console.log("Provider======", Provider)
    console.log("walletType======", walletType)
    console.log("nft======", nft)
    console.log("adress======", adress)
    console.log("request======", request)

    const usePrice = 273
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    var currentNetworkAddress = null
    var currentRPC = null
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
    }

    var currentNetworkAddress = null
    var ERC1155Address = null
    var currentPrice = null
    var alhijanadress = null

    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      ERC1155Address = `${process.env.REACT_APP_MUMBAI_ER1155}`
      currentPrice = 'MATIC'
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      ERC1155Address = `${process.env.REACT_APP_BINANCE_ER1155}`
      currentPrice = 'BNB'
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      ERC1155Address = `${process.env.REACT_APP_RINKEY_ER1155}`
      currentPrice = 'ETH'
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
    }

    if (walletType == 'WALLETCONNECT') {
      try {
        const web3 = new Web3(currentRPC)
        const ERC20Contract =
          nft?.camerlNfts != true
            ? new web3.eth.Contract(sell['abi'], currentNetworkAddress)
            : new web3.eth.Contract(alhijan['abi'], alhijanadress)

        //const ERC20Contract = new web3.eth.Contract(alhijan['abi'], alhijanadress)
        console.log("====ERC20Contract===", ERC20Contract)
        const gasPrice = await web3.eth.getGasPrice()
        console.log("===gasPrice=====", gasPrice)
        const gas =
          nft?.camerlNfts != true
            ? await ERC20Contract?.methods
              ?.removeUserAuction([nft?.onionId])
              .estimateGas({ from: adress, gasPrice: gasPrice })
            : await ERC20Contract?.methods
              ?.removeCamelAuction(nft?.auctionId)
              ?.estimateGas({ from: adress, gasPrice: gasPrice })

        // const gas = await ERC20Contract?.methods
        //   ?.removeCamelAuction(nft?.auctionId)
        //   ?.estimateGas({ from: adress, gasPrice: gasPrice })

        console.log("===gas=====", gas)

        const txPriceWeiApprove = gas * gasPrice
        const txPriceEthBuy = await web3.utils.fromWei(
          txPriceWeiApprove.toString(),
          'ether'
        )
        const txPriceUSDBuy = (txPriceEthBuy * usePrice) / 273
        console.log("===txPriceEthBuy=====", txPriceUSDBuy)
        //console.log(ERC20Contract)
        let extraData1 =
          nft?.camerlNfts != true
            ? await ERC20Contract?.methods?.removeUserAuction([nft?.onionId])
            : await ERC20Contract?.methods?.removeCamelAuction(nft?.auctionId)

        //let extraData1 = await ERC20Contract?.methods?.removeCamelAuction(nft?.auctionId)
        console.log("extraData1====", extraData1)
        let data1 = extraData1.encodeABI()
        console.log("data1==", data1)
        // const dataObj1 = {
        //   data: data1,
        //   amount: parseFloat(txPriceUSDBuy).toFixed(10),
        //   gasPrice: gasPrice,
        //   gasLimit: gas
        // }
        // let parsedata2 = JSON.stringify(dataObj1)
        // console.log("dataObj1==", dataObj1)
        console.log("checking ==", {
          to: alhijanadress,
          data: data1,
          gasPrice: web3.utils.toHex(gasPrice),
          gasLimit: web3.utils.toHex(gas),
          amount: parseFloat(txPriceUSDBuy).toFixed(10),
          symbol: currentPrice
        })
        request({
          topic: Provider?.topic,
          chainId: 'eip155:1',
          request: {
            id: 1,
            jsonrpc: '2.0',
            method: 'eth_signTransaction',
            params: [
              {
                to: nft?.camerlNfts != true
                  ? currentNetworkAddress
                  : alhijanadress,
                data: data1,
                gasPrice: web3.utils.toHex(gasPrice),
                gasLimit: web3.utils.toHex(gas),
                amount: parseFloat(txPriceUSDBuy).toFixed(10),
                symbol: currentPrice
              }
            ]
          }
        })
          .then(data => {
            web3.eth
              .sendSignedTransaction(data)
              .then(data => {
                callBack(null, data)
              })
              .catch(err => {
                callBack(err, null)
              })
          })
          .catch(err => {
            callBack(err, null)
          })
      } catch (err) {
        callBack(err, null)
      }

    } else {
      try {
        const ERC20Contract =
          nft?.camerlNfts != true
            ? await this.providerRPC(
              Provider,
              currentNetworkAddress,
              sell['abi']
            )
            : await this.providerRPC(Provider, alhijanadress, alhijan['abi'])
        console.log(ERC20Contract)
        let methods =
          nft?.camerlNfts != true
            ? ERC20Contract?.methods?.removeUserAuction([nft?.onionId]).send({
              from: adress
            })
            : ERC20Contract?.methods?.removeCamelAuction(nft?.onionId).send({
              from: adress
            })
        await methods
          .on('transactionHash', data => {
            //console.log(data)
          })

          .on('receipt', async function (hash) {
            callBack(null, hash)
          })
          .on('error', err => {
            callBack(err, null)
          })
      } catch (err) {
        callBack(err, null)
      }
    }
  },
  async renewSell(
    Provider,
    walletType,
    nft,
    adress,
    transactiondata,
    token,
    request,
    callBack
  ) {
    // const currentNetwork = localStorage.getItem("currentNetwork") || 'MUMBAI
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    var currentNetworkAddress = null
    var currentRPC = null
    var alhijanadress = null
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      currentRPC = `${process.env.REACT_APP_POLYGON_RPCURL}`
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      currentRPC = `${process.env.REACT_APP_BINANCE_PROVIDER}`
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      currentRPC = `${process.env.REACT_APP_ROPSTAN_PROVIDER}`
      alhijanadress = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
    }
    let currency =
      '0x4558530000000000000000000000000000000000000000000000000000000000'
    let price = '0'
    if (currentnetwork == 'MUMBAI') {
      if (nft?.currency == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    } else if (currentnetwork == 'BINANCE') {
      if (nft?.currency == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      }
    } else {
      if (nft?.currency == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nft?.pricePerCard)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    }

    var currentNetworkAddress = null
    var ERC1155Address = null
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      ERC1155Address = `${process.env.REACT_APP_MUMBAI_ER1155}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      ERC1155Address = `${process.env.REACT_APP_BINANCE_ER1155}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      ERC1155Address = `${process.env.REACT_APP_RINKEY_ER1155}`
    }

    if (walletType == 'WALLETCONNECT') {
      const web3 = new Web3(currentRPC)
      const ERC20Contract =
        nft?.camerlNfts != true
          ? new web3.eth.Contract(sell['abi'], currentNetworkAddress)
          : new web3.eth.Contract(alhijan['abi'], alhijanadress)
      const gasPrice = await web3.eth.getGasPrice()
      const gas =
        nft?.camerlNfts != true
          ? await ERC20Contract?.methods
            ?._updateUserAuction(nft?.onionId, price, nft?.deadline)
            .estimateGas({ from: adress, gasPrice: gasPrice })
          : await ERC20Contract?.methods
            ?.reAuctionCamel(nft?.onionId, price, nft?.deadline)
            .estimateGas({ from: adress, gasPrice: gasPrice })
      //console.log(ERC20Contract)
      let extraData1 =
        nft?.camerlNfts != true
          ? await ERC20Contract?.methods?._updateUserAuction(
            nft?.onionId,
            price,
            nft?.deadline
          )
          : await ERC20Contract?.methods?.reAuctionCamel(
            nft?.onionId,
            price,
            nft?.deadline
          )
      //console.log(extraData1)
      let data1 = extraData1.encodeABI()
      const dataObj1 = {
        data: data1,
        amount: parseFloat('0.1'),
        gasPrice: gasPrice,
        gasLimit: gas
      }
      let parsedata2 = JSON.stringify(dataObj1)
      //console.log(data1)

      request({
        topic: Provider?.topic,
        chainId: 'eip155:1',
        request: {
          id: 1,
          jsonrpc: '2.0',
          method: 'eth_signTransaction',
          params: [
            {
              to: nft?.camerlNfts != true ? currentNetworkAddress : alhijan,
              data: data1,
              amount: parseFloat('0.1'),
              gasPrice: web3.utils.toHex(gasPrice),
              gasLimit: web3.utils.toHex(gas),
              symbol: nft?.currency
            }
          ]
        }
      })
        .then(data => {
          web3.eth
            .sendSignedTransaction(data)
            .on('transactionHash', data => {
              buyNfts?.buyProduct(
                {
                  ...transactiondata,
                  transaction: data,
                  status: 2
                },
                token,
                (err, element) => { }
              )
            })
            .once('receipt', hash => {
              //console.log(hash)
              callBack(null, hash)
            })
            .on('error', err => {
              //console.log(err)
              callBack(err, null)
            })
        })
        .catch(err => {
          callBack(err, null)
        })
    } else {
      try {
        const ERC20Contract =
          nft?.camerlNfts != true
            ? await this.providerRPC(
              Provider,
              currentNetworkAddress,
              sell['abi']
            )
            : await this.providerRPC(Provider, alhijanadress, alhijan['abi'])
        let methods =
          nft?.camerlNfts != true
            ? await ERC20Contract?.methods?._updateUserAuction(
              nft?.onionId,
              price,
              nft?.deadline
            )
            : await ERC20Contract?.methods?.reAuctionCamel(
              nft?.onionId,
              price,
              nft?.deadline
            )

        methods
          .send({
            from: adress
          })
          ?.on('transactionHash', data => {
            //console.log(data)
            buyNfts?.buyProduct(
              {
                ...transactiondata,
                transaction: data,
                status: 2
              },
              token,
              (err, element) => { }
            )
          })

          .on('receipt', async function (hash) {
            callBack(null, hash)
          })
          .on('error', err => {
            callBack(err, null)
          })
      } catch (err) {
        callBack(err, null)
      }
    }
  },
  async sellCamelNftswithWalletConnect(
    connector,
    item,
    walletAddress = '',
    nftdata,
    transactiondata,
    token,
    request,
    callBack
  ) {
    var usdprice = null
    try {
      usdprice = await axios?.get(
        'https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD,EUR'
      )
    } catch {
      callBack('Something Went Wrong', null)
      return
    }

    const currentNetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    const currentNetworkRPC =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYGON_RPCURL}`
          : `${process.env.REACT_APP_BINANCE_PROVIDER}`
        : `${process.env.REACT_APP_POLYGON_RPCURL}`
    //console.log(currentNetwork)
    const web3 = new Web3(currentNetworkRPC)
    let currency =
      '0x4558530000000000000000000000000000000000000000000000000000000000'
    let price = '0'
    if (currentNetwork == 'MUMBAI') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    } else if (currentNetwork == 'BINANCE') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      }
    } else {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    }
    const owner = walletAddress
    const quanity = nftdata?.quantity
    const duration = nftdata?.duration
    const nftid = item?.tokenId
    //console.log(item)
    // alert(item?.tokenId)

    var currentCurrency = null
    var Alhijan = null
    var erc20adress = null
    var erc721 = null
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    if (currentnetwork == 'MUMBAI') {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_POLY}`
      currentCurrency = 'MATIC'
    } else if (currentnetwork == 'BINANCE') {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
      currentCurrency = 'BNB'
    } else {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_ETH}`
      currentCurrency = 'ETH'
    }

    const alhijanContract = new web3.eth.Contract(alhijan['abi'], Alhijan)
    const Erc20Contract = new web3.eth.Contract(
      CamelGameerc20['abi'],
      erc20adress
    )

    console.log("====checking *********",)

    const Erc721 = new web3.eth.Contract(CamelGameerc721['abi'], erc721)

    const gasPrice = await web3.eth.getGasPrice()
    const gasLimit = await Erc721.methods
      .approve(Alhijan, item?.tokenId)
      .estimateGas({ from: owner, gasPrice: gasPrice })

    const txPriceWeiApprove = gasLimit * gasPrice
    const txPriceEthBuy = await web3.utils.fromWei(
      txPriceWeiApprove.toString(),
      'ether'
    )
    const txPriceUSDBuy =
      (txPriceEthBuy * usdprice?.data.USD) / usdprice?.data.USD
    //console.log(gasLimit)
    console.log(nftdata)
    let extraData = await Erc721.methods.approve(Alhijan, item?.tokenId)
    //console.log(extraData)
    let data = extraData.encodeABI()
    const dataObj = {
      data: data,
      gasPrice: gasPrice,
      gasLimit: gasLimit,
      amount: parseFloat(txPriceUSDBuy).toFixed(10)
    }
    console.log({
      to: erc721,
      data: data,
      amount: parseFloat(txPriceUSDBuy).toFixed(10),
      gasPrice: web3.utils.toHex(gasPrice),
      gasLimit: web3.utils.toHex(gasLimit),
      symbol: currentCurrency
    })
    request({
      topic: connector?.topic,
      chainId: 'eip155:1',
      request: {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_signTransaction',
        params: [
          {
            to: erc721,
            data: data,
            amount: parseFloat(txPriceUSDBuy).toFixed(10),
            gasPrice: web3.utils.toHex(gasPrice),
            gasLimit: web3.utils.toHex(gasLimit),
            symbol: currentCurrency
          }
        ]
      }
    }).then(data => {
      console.log(data)
      web3.eth
        .sendSignedTransaction(data)
        .on('transactionHash', data => {
          console.log(data)
        })
        .once('receipt', async hash => {
          console.log(hash)
          const gasPriceCreateAuction = await web3.eth.getGasPrice()
          console.log(alhijanContract)

          const gas1 = await alhijanContract?.methods
            ?.createCamelAuction(
              nftid,
              owner,
              nftdata?.coin?.toUpperCase(),
              price,
              duration
            )
            .estimateGas({ from: owner, gasPrice: gasPriceCreateAuction })

          const txPriceWeiCreateAuction = gas1 * gasPriceCreateAuction
          const txPriceEthCreateAuction = await web3.utils.fromWei(
            txPriceWeiCreateAuction.toString(),
            'ether'
          )
          //console.log(txPriceEthCreateAuction * usdprice?.data.USD)
          const txPriceUSDCreateAuction =
            (txPriceEthCreateAuction * usdprice?.data.USD) /
            usdprice?.data.USD
          let extraData1 = await alhijanContract?.methods?.createCamelAuction(
            nftid,
            owner,
            nftdata?.coin?.toUpperCase(),
            price,
            duration
          )

          //console.log(extraData1)
          let data1 = extraData1.encodeABI()
          const dataObj1 = {
            data: data1,
            amount: parseFloat(txPriceUSDCreateAuction).toFixed(10),
            gasPrice: gasPriceCreateAuction,
            gasLimit: gas1
          }
          request({
            topic: connector?.topic,
            chainId: 'eip155:1',
            request: {
              id: 1,
              jsonrpc: '2.0',
              method: 'eth_signTransaction',
              params: [
                {
                  to: Alhijan,
                  data: data1,
                  amount: parseFloat(txPriceUSDCreateAuction).toFixed(10),
                  gasPrice: web3.utils.toHex(gasPriceCreateAuction),
                  gasLimit: web3.utils.toHex(gas1),
                  symbol: currentCurrency
                }
              ]
            }
          })
            .then(data => {
              web3.eth
                .sendSignedTransaction(data)
                .on('transactionHash', data => {
                  buyNfts?.buyProduct(
                    {
                      ...transactiondata,
                      transaction: data,
                      status: 2
                    },
                    token,
                    (err, element) => { }
                  )
                })
                .once('receipt', hash => {
                  //console.log(hash)
                  callBack(null, hash?.transactionHash)
                })
                .on('error', err => {
                  //console.log(err)
                  callBack(err, null)
                })
            })
            .catch(err => {
              callBack(err, null)
            })
        })
        .on('error', err => {
          //console.log(err)
          callBack(err, null)
        })
    })
      .catch(err => {
        callBack(err, null)
      })
  },
  async sellNftswithWalletConnect(
    connector,
    item,
    walletAddress = '',
    nftdata,
    transactiondata,
    token,
    request = {},
    callBack
  ) {
    var usdprice = null
    try {
      usdprice = await axios?.get(
        'https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD,EUR'
      )
    } catch {
      callBack('Something Went Wrong', null)
      return
    }

    const currentNetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    const currentNetworkRPC =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYGON_RPCURL}`
          : `${process.env.REACT_APP_BINANCE_PROVIDER}`
        : `${process.env.REACT_APP_POLYGON_RPCURL}`
    //console.log(currentNetwork)
    const web3 = new Web3(currentNetworkRPC)
    let currency =
      '0x4558530000000000000000000000000000000000000000000000000000000000'
    let price = '0'
    if (currentNetwork == 'MUMBAI') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    } else if (currentNetwork == 'BINANCE') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      }
    } else {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    }
    const owner = walletAddress
    const quanity = nftdata?.quantity
    const duration = nftdata?.duration
    const nftid = item?.tokenId
    //console.log(item)

    var currentNetworkAddress = null
    var currentCurrency = null
    var ERC1155Address = null
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      ERC1155Address = `${process.env.REACT_APP_MUMBAI_ER1155}`
      currentCurrency = 'MATIC'
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      ERC1155Address = `${process.env.REACT_APP_BINANCE_ER1155}`
      currentCurrency = 'BNB'
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      ERC1155Address = `${process.env.REACT_APP_RINKEY_ER1155}`
      currentCurrency = 'ETH'
    }

    const ERC20Contract = new web3.eth.Contract(
      sell['abi'],
      currentNetworkAddress
    )
    const ERC1155Contract = new web3.eth.Contract(
      erc1155['abi'],
      ERC1155Address
    )
    const gasPrice = await web3.eth.getGasPrice()
    const gasLimit = await ERC1155Contract.methods
      .setApprovalForAll(currentNetworkAddress, 'true')
      .estimateGas({ from: owner, gasPrice: gasPrice })

    const txPriceWeiApprove = gasLimit * gasPrice
    const txPriceEthBuy = await web3.utils.fromWei(
      txPriceWeiApprove.toString(),
      'ether'
    )
    const txPriceUSDBuy =
      (txPriceEthBuy * usdprice?.data.USD) / usdprice?.data.USD
    //console.log(gasLimit)

    let extraData = await ERC1155Contract.methods.setApprovalForAll(
      currentNetworkAddress,
      'true'
    )
    //console.log(extraData)
    let data = extraData.encodeABI()
    const dataObj = {
      data: data,
      gasPrice: gasPrice,
      gasLimit: gasLimit,
      amount: parseFloat(txPriceUSDBuy).toFixed(10)
    }

    //console.log('I am Here')
    console.log({
      to: ERC1155Address,
      data: data,

      amount: parseFloat(txPriceUSDBuy).toFixed(10),
      gasPrice: web3.utils.toHex(gasPrice),
      gasLimit: web3.utils.toHex(gasLimit),

      symbol: currentCurrency
    })
    request({
      topic: connector?.topic,
      chainId: 'eip155:1',
      request: {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_signTransaction',
        params: [
          {
            to: ERC1155Address,
            data: data,

            amount: parseFloat(txPriceUSDBuy).toFixed(10),
            gasPrice: web3.utils.toHex(gasPrice),
            gasLimit: web3.utils.toHex(gasLimit),

            symbol: currentCurrency
          }
        ]
      }
    })
      .then(data => {
        console.log(data)
        web3.eth
          .sendSignedTransaction(data)
          .then(async data => {
            console.log(data)
            const gasPriceCreateAuction = await web3.eth.getGasPrice()
            const gas1 = await ERC20Contract.methods
              .createUserAuction(
                [nftid],
                owner,
                currency,
                [quanity],
                [price],
                [duration]
              )
              .estimateGas({ from: owner, gasPrice: gasPriceCreateAuction })

            const txPriceWeiCreateAuction = gas1 * gasPriceCreateAuction
            const txPriceEthCreateAuction = await web3.utils.fromWei(
              txPriceWeiCreateAuction.toString(),
              'ether'
            )
            //console.log(txPriceEthCreateAuction * usdprice?.data.USD)
            const txPriceUSDCreateAuction =
              (txPriceEthCreateAuction * usdprice?.data.USD) /
              usdprice?.data.USD
            let extraData1 = await ERC20Contract.methods.createUserAuction(
              [nftid],
              owner,
              currency,
              [quanity],
              [price],
              [duration]
            )
            //console.log(extraData1)
            let data1 = extraData1.encodeABI()

            request({
              topic: connector?.topic,
              chainId: 'eip155:1',
              request: {
                id: 1,
                jsonrpc: '2.0',
                method: 'eth_signTransaction',
                params: [
                  {
                    to: currentNetworkAddress,
                    data: data1,

                    amount: parseFloat(txPriceUSDCreateAuction).toFixed(10),
                    gasPrice: web3.utils.toHex(gasPriceCreateAuction),
                    gasLimit: web3.utils.toHex(gas1),
                    symbol: currentCurrency
                  }
                ]
              }
            })
              .then(data => {
                console.log(data)
                web3.eth
                  .sendSignedTransaction(data)
                  .on('transactionHash', data => {
                    buyNfts?.buyProduct(
                      {
                        ...transactiondata,
                        transaction: data,
                        status: 2
                      },
                      token,
                      (err, element) => { }
                    )
                  })
                  .once('receipt', hash => {
                    //console.log(hash)
                    callBack(null, hash?.transactionHash)
                  })
                  .on('error', err => {
                    //console.log(err)
                    callBack(err, null)
                  })
              })
              .catch(err => {
                callBack(err, null)
              })
          })
          .catch(err => {
            callBack(err, null)
          })
      })
      .catch(err => {
        callBack(err, null)
      })
  },
  async sellcamelNfts(
    Provider,
    item,
    walletAddress = '',
    nftdata,
    transactiondata,
    token,
    callBack
  ) {
    const currentNetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    let currency =
      '0x4558530000000000000000000000000000000000000000000000000000000000'
    let price = '0'
    if (currentNetwork == 'MUMBAI') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    } else if (currentNetwork == 'BINANCE') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      }
    } else {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    }

    // const currency = '0x5553445400000000000000000000000000000000000000000000000000000000'
    // const currency = "0x4558530000000000000000000000000000000000000000000000000000000000"
    // const price = currency == "0x4558530000000000000000000000000000000000000000000000000000000000" ? '500000000000000000' : '500000'
    const owner = walletAddress
    const quanity = nftdata?.quantity
    const duration = nftdata?.duration
    const nftid = item?.tokenId
    //console.log(item)

    var Alhijan = null
    var erc20adress = null
    var erc721 = null
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    console.log("====currentnetwork======", currentnetwork)
    if (currentnetwork == 'MUMBAI') {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_POLY}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_POLY}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_POLY}`
    } else if (currentnetwork == 'BINANCE') {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_BINANCE}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_BINANCE}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_BINANCE}`
    } else {
      Alhijan = `${process.env.REACT_APP_CAMELGAME_ALHIJAN_ETH}`
      erc20adress = `${process.env.REACT_APP_CAMELGAME_ERC20_ETH}`
      erc721 = `${process.env.REACT_APP_CAMELGAME_ERC721_ETH}`
    }
    const ERC20Contract = await this.providerRPC(
      Provider,
      erc20adress,
      CamelGameerc20['abi']
    )
    console.log(ERC20Contract)
    const ERC721Contract = await this.providerRPC(
      Provider,
      erc721,
      CamelGameerc721['abi']
    )
    const alhijanContract = await this.providerRPC(
      Provider,
      Alhijan,
      alhijan['abi']
    )
    console.log("===alhihin alhijanContract ", alhijanContract)
    console.log(ERC721Contract)
    console.log(nftid)
    console.log('approve method', Alhijan, nftid)
    ERC721Contract.methods
      ?.approve(Alhijan, nftid)
      .send({
        from: owner
      })
      .then(data => {
        console.log('sell method')
        alhijanContract?.methods
          ?.createCamelAuction(
            nftid,
            owner,
            nftdata?.coin?.toUpperCase(),
            price,
            duration
          )
          .send({
            from: owner
          })
          .on('transactionHash', data => {
            //console.log(data)
            buyNfts?.buyProduct(
              {
                ...transactiondata,
                transaction: data,
                status: 2
              },
              token,
              (err, element) => { }
            )
          })

          .on('receipt', async function (hash) {
            //console.log(hash)
            callBack(null, hash)
          })
          .on('error', err => {
            callBack(err, null)
          })
      })
      .catch(err => {
        //console.log(err)
        callBack(err, null)
      })
    // result2.then(async () => {
  },
  async sellNfts(
    Provider,
    item,
    walletAddress = '',
    nftdata,
    transactiondata,
    token,
    callBack
  ) {
    const currentNetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    let currency =
      '0x4558530000000000000000000000000000000000000000000000000000000000'
    let price = '0'
    if (currentNetwork == 'MUMBAI') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    } else if (currentNetwork == 'BINANCE') {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      }
    } else {
      if (nftdata?.coin == 'EXS') {
        currency =
          '0x4558530000000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(18))
          .toFixed()
      } else {
        currency =
          '0x5553445400000000000000000000000000000000000000000000000000000000'
        price = new BigNumber(nftdata?.price)
          .times(new BigNumber(10).pow(6))
          .toFixed()
      }
    }
    //console.log(walletAddress)
    //console.log(nftdata)
    //console.log(price)
    // const currency = '0x5553445400000000000000000000000000000000000000000000000000000000'
    // const currency = "0x4558530000000000000000000000000000000000000000000000000000000000"
    // const price = currency == "0x4558530000000000000000000000000000000000000000000000000000000000" ? '500000000000000000' : '500000'
    const owner = walletAddress
    const quanity = nftdata?.quantity
    const duration = nftdata?.duration
    const nftid = item?.tokenId
    //console.log(item)

    var currentNetworkAddress = null
    var ERC1155Address = null
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      ERC1155Address = `${process.env.REACT_APP_MUMBAI_ER1155}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      ERC1155Address = `${process.env.REACT_APP_BINANCE_ER1155}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      ERC1155Address = `${process.env.REACT_APP_RINKEY_ER1155}`
    }
    const ERC20Contract = await this.providerRPC(
      Provider,
      currentNetworkAddress,
      sell['abi']
    )
    //console.log(ERC20Contract)
    const ERC1155Contract = await this.providerRPC(
      Provider,
      ERC1155Address,
      erc1155['abi']
    )
    //console.log(ERC1155Contract)
    //console.log(owner)
    //console.log(currentNetworkAddress)
    ERC1155Contract.methods
      .setApprovalForAll(currentNetworkAddress, 'true')
      .send({ from: owner })
      .then(data => {
        //console.log(data)
        ERC20Contract.methods
          .createUserAuction(
            [nftid],
            owner,
            currency,
            [quanity],
            [price],
            [duration]
          )
          .send({ from: owner })
          .on('transactionHash', data => {
            //console.log(data)
            buyNfts?.buyProduct(
              {
                ...transactiondata,
                transaction: data,
                status: 2
              },
              token,
              (err, element) => { }
            )
          })

          .on('receipt', async function (hash) {
            //console.log(hash)
            callBack(null, hash)
          })
          .on('error', err => {
            callBack(err, null)
          })
      })
      .catch(err => {
        //console.log(err)
        callBack(err, null)
      })
    // result2.then(async () => {
  },

  /**
   * Format from Solidity types to JS types
   * @param {Object} auction auction data with solidity types of the auctions
   * @param {Object} tokens cosntant to get data token
   * @returns {Object} a formated Object with JS types
   */
  formatAuctionData(auction, tokens) {
    //console.log(auction)
    //console.log(tokens)
    if (tokens != null && tokens != undefined) {
      const currency = utils.fromBytes32(auction._currency)
      const token = tokens.find(x => x.name == currency.toUpperCase())
      if (token != undefined) {
        const pricePerCard = this.toDecimals(auction._pricePerCard, token)
        const incrementer = this.toDecimals(auction._incrementer, token)
        let auctionFormatted = {
          auctioner: auction._owner,
          tokenId: parseInt(auction._cardId.toString()),
          currency: currency,
          amount: Number(auction._amountOnSale.toString()),
          pricePerCard: pricePerCard,
          incrementer: incrementer
        }
        if (auction._deadline) {
          auctionFormatted.duration = Number(auction?._duration.toString())
          auctionFormatted.deadline = Number(auction?._deadline.toString())
        }
        return auctionFormatted
      } else {
        return {}
      }
    } else {
      const auctionFormatted = {
        auctioner: auction._owner,
        tokenId: parseInt(auction._cardId.toString()),

        amount: Number(auction._amountOnSale.toString())
      }
      if(auction._deadline) {
        auctionFormatted.deadline = Number(auction?._deadline.toString())
      }
      return auctionFormatted
    }
  },
  formatAuctionDataCamel(auction, tokens) {
    try {
      if (tokens != null && tokens != undefined) {
        const token = tokens.find(x => x.name == auction.currency.toUpperCase())

        if (token != undefined) {
          const pricePerCard = this.toDecimals(auction.pricePerCamel, token)
          // const incrementer = this.toDecimals(auction._incrementer, token)
          const auctionFormatted = {
            auctioner: auction.owner,
            tokenId: parseInt(auction.camelId),
            currency: auction.currency.toUpperCase(),
            // amount: auction._amountOnSale,
            pricePerCard: pricePerCard,
            incrementer: 0,
            deadline: auction?.validDate
            // duration: auction?._deadline
          }
          return auctionFormatted
        } else {
          return {}
        }
      } else {
        const auctionFormatted = {
          auctioner: auction.owner,
          tokenId: parseInt(auction.camelId),

          // amount: auction.,
          deadline: auction?.validDate
        }
        return auctionFormatted
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   *
   * @param {Object} contractInfo Constant data of the onionAuction
   * @param {Object} tokens cosntant to get data token
   * @returns {Array} Array formated of each auction avalaible.
   */
  async sellOnionAuction(tokens) {
    try {
      var currentNetworkAddress = null
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      if (currentnetwork == 'MUMBAI') {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      } else if (currentnetwork == 'BINANCE') {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      } else {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      }
      const sellcontract = await this.mobileProvider(
        currentNetworkAddress,
        sell['abi']
      )
      // return array with the auctionsID uint256[1,2,344,5]
      const sellAuctionIds = await sellcontract.methods
        .getAllUsersAuctionId()
        .call()
      //console.log(sellAuctionIds)
      const sellAuctionDetails = await sellcontract.methods
        .batchDetailsUserAuction(sellAuctionIds)
        .call()
      var sellAuction = []
      //console.log(sellAuctionDetails)
      sellAuctionDetails.forEach((auction, index) => {
        if (auction['_pricePerCard'] != 0) {
          let formated = this.formatAuctionData(auction, tokens)
          formated.onionId = sellAuctionIds[index]
          formated.extradetails = auction
          sellAuction.push(formated)
        }
      })
      //console.log(sellAuction)
      return sellAuction
    } catch (e) { }
  },
  async onionAuctions(contractInfo, tokens) {
    try {
      const auctions = []
      const contract = await this.mobileProvider(
        contractInfo.address,
        onion['abi']
      )
      const batchAuctions = await contract.methods.getAllOnionsId().call()
      // return a solidity struct => js Object (_owner _athleteLoyalty _currency _cardId _amountOnSale _pricePerCard _incrementer;
      const auctionsDetails = await contract.methods
        .batchDetailsOnions(batchAuctions)
        .call()
      auctionsDetails.forEach((auction, index) => {
        let formated = this.formatAuctionData(auction, tokens)
        formated.onionId = batchAuctions[index]
        formated.extradetails = auction
        auctions.push(formated)
      })
      return auctions
    } catch (error) {
      //console.log(error)
    }
  },

  formatAuctionUpdated(auctionData, tokens) {
    // //console.log(auctionData)
    const currentNetwork = localStorage?.getItem('currentNetwork') || 'MUMBAI'
    const env = `${process.env.REACT_APP_ENVIRONMENT}`
    //console.log(tokens)
    //console.log(auctionData)
    const currency =
      currentNetwork == 'MUMBAI' && env == 'live'
        ? utils.fromBytes32(auctionData[2])
        : utils.fromBytes32(auctionData[1])
    //console.log(currency)
    const token = tokens.find(x => x.name == currency.toUpperCase())
    const pricePerCard = this.toDecimals(auctionData[4], token)
    const incrementer = this.toDecimals(auctionData[5], token)
    return {
      amount: auctionData[3],
      pricePerCard: parseFloat(pricePerCard).toFixed(2),
      incrementer: parseFloat(incrementer).toFixed(2)
    }
  },
  async auction(onion, auction, tokens) {
    //console.log(onion)
    //console.log(auction)
    var auctionData = null
    if (auction?.onSell == false) {
      auctionData = await onion.methods
        .onionAuctionDetails(auction.onionId)
        .call()
    } else {
      auctionData = await onion.methods
        .validAuctionDetails(auction.onionId)
        .call()
    }
    // await onion.methods.userAuctionDetails(auction.onionId).call()
    //console.log(this.formatAuctionUpdated)
    //console.log(auctionData)
    var formated = this.formatAuctionUpdated(auctionData, tokens)
    //console.log(formated)
    return formated
  },
  /**
   *
   * @param {Object} Provider wallet provider
   * @param {String} address user Address
   * @param {Object} auction Auction to buy
   * @param {Object} onionContract constant Data of the Onion contract
   * @param {Object} tokens cosntant to get data token
   * @param {Object} dispatch
   * @param {Object} popup state from 'notificationSystem' module
   * @returns {Boolean} if the transactions have been sent correctly, it returns true,
   * but this does not mean that the purchase has been successful,
   * since it is necessary to wait for the miners to validate the tx,
   *  and successfully add the tx's to the block.
   * you must have to weigh that the transaction appears as sent
   * but in the blockchain it is reversed or sent and validated correctly.
   */
  async sendTokenWithExs(
    provider,
    amount,
    reciver,
    sender,
    tokenAddress,
    callback
  ) {
    try {
      const web3 = new Web3(`${process.env.REACT_APP_ROPSTAN_PROVIDER}`)
      //console.log(reciver)
      var count = await web3.eth.getTransactionCount(sender)
      //console.log(count)
      var destAddress = reciver
      var transferAmount = amount
      // var contractAddress = "0xDD5CBBfb58B1463611433b12d256DC30AE24BF42";
      var contractAddress = tokenAddress
      var contract = new web3.eth.Contract(erc20['abi'], contractAddress, {
        from: sender
      })
      //console.log(contract)
      var balance = await contract.methods.balanceOf(sender).call()
      //console.log(balance / 10 ** 18)
      var gasPriceGwei = 3
      var gasLimit = 6000000
      var chainId = 1
      try {
        provider
          .getSigner(sender)
          .sendTransaction({
            to: contractAddress,
            gasPrice: web3.utils.toHex(gasPriceGwei * 1e9),
            gasLimit: web3.utils.toHex(gasLimit),
            from: sender,
            nonce: '0x' + count.toString(16),
            value: ethers.utils.parseEther('0.0'),
            data: contract.methods
              .transfer(destAddress, transferAmount)
              .encodeABI()
          })
          .then(signature => {
            //console.log(signature) // todo remove dev item
            // setHash(signature.hash);
            // window.alert(`Success!\n\n${signature}`)
            callback(null, signature)
          })
          .catch(error => {
            // window.alert('Failure!' + (error && error.message ? `\n\n${error.message}` : ''))
            //console.log(error)
            callback(error, null)
          })
      } catch (e) {
        callback(e, null)
      }
    } catch (err) {
      //console.log(err)
    }
  },
  async buynftwithwalletconnect(
    connector,
    account,
    auction,
    savetransaction,
    token,
    request,
    callback
  ) {
    // New Changes for walletconnect
    console.log(auction)
    const currentNetwork =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYGON_RPCURL}`
          : `${process.env.REACT_APP_BINANCE_PROVIDER}`
        : `${process.env.REACT_APP_POLYGON_RPCURL}`
    console.log("Current Network:::::::"+currentNetwork)
    const web3 = new Web3(currentNetwork)
    const addressFrom = account
    const addressTo = '0xb67C9263F86934461F9CB10468B72B15d9a9140A'
    const erc20ContractAddress =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? auction?.currency == 'EXS'
            ? `${process.env.REACT_APP_MUMBAI_ER20}`
            : `${process.env.REACT_APP_USDT_POLY}`
          : auction?.currency == 'EXS'
            ? `${process.env.REACT_APP_BINANCE_ER20}`
            : `${process.env.REACT_APP_USDT_BNB}`
        : auction?.currency == 'EXS'
          ? `${process.env.REACT_APP_MUMBAI_ER20}`
          : `${process.env.REACT_APP_USDT_POLY}`
    console.log(erc20ContractAddress)
    const onionContractAddress =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_MUMBAI_ONION}`
          : `${process.env.REACT_APP_BINANCE_ONION}`
        : `${process.env.REACT_APP_MUMBAI_ONION}`
    console.log(onionContractAddress)
    const erc20Contract = new web3.eth.Contract(
      erc20['abi'],
      erc20ContractAddress
    )
    //console.log(erc20Contract)
    const contractAuction = new web3.eth.Contract(
      onion['abi'],
      onionContractAddress
    )
    //console.log(contractAuction)

    const chainId =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYID}`
          : `${process.env.REACT_APP_BINANCEID}`
        : `${process.env.REACT_APP_POLYID}`
    var zerosToAdd = '000000000000000000'
    var decimal = 18
    if (localStorage.getItem('currentNetwork') == 'MUMBAI') {
      zerosToAdd = auction?.currency == 'EXS' ? '000000000000000000' : '000000'
      decimal = auction?.currency == 'EXS' ? 18 : 6
    } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
      zerosToAdd = '000000000000000000'
      decimal = 18
    } else {
      zerosToAdd = auction?.currency == 'EXS' ? '000000000000000000' : '000000'
      decimal = auction?.currency == 'EXS' ? 18 : 6
    }
    const price = parseFloat(auction?.auction?.pricePerCard)
    const newPrice = ethers.utils.parseUnits(price + 0.1 + zerosToAdd, decimal)

    var transferAmount = new BigNumber(
      parseFloat(auction?.auction?.pricePerCard).toFixed(2)
    )
      .times(new BigNumber(10).pow(decimal))
      .toFixed()
    const gasPrice1 = await web3.eth.getGasPrice()
    const gasLimit1 = await erc20Contract.methods
      .approve(onionContractAddress, newPrice)
      .estimateGas({ from: account, gasPrice: gasPrice1 })

    //console.log(auction?.auction?.pricePerCard)

    let extraData = await erc20Contract.methods.approve(
      onionContractAddress,
      newPrice
    )
    //console.log(extraData)
    //console.warn(newPrice)
    let dataApprove = extraData.encodeABI()
    console.log(dataApprove)
    const web4 = new Web3('https://data-seed-prebsc-1-s3.binance.org:8545/')
    console.log("==connector?.topic===", connector?.topic)
    console.log(gasPrice1)
    console.log(gasLimit1)
    request({
      topic: connector?.topic,
      chainId: 'eip155:1',
      request: {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_signTransaction',
        params: [
          {
            to: erc20ContractAddress,
            data: dataApprove,
            gasPrice: web3.utils.toHex(gasPrice1),
            gasLimit: web3.utils.toHex(gasLimit1),
            amount: parseFloat(auction?.auction?.pricePerCard).toFixed(2),
            symbol: auction.currency
          }
        ]
      }
    })
      .then(data => {
        console.log("WC: Response:::::::",data)
        web3.eth
          .sendSignedTransaction(data)
          .then(async data => {
            console.log("Sign Response: Response:::::::",data)
            const gasPrice2 = await web3.eth.getGasPrice()
            const gasLimit2 = await contractAuction.methods
              .buyCard(auction?.auction.onionId, addressFrom)
              .estimateGas({ from: account, gasPrice: gasPrice2 })
            let extraData1 = await contractAuction.methods.buyCard(
              auction?.auction.onionId,
              addressFrom
            )
            //console.log(extraData1)
            let data1 = extraData1.encodeABI()
            const dataObj1 = {
              data: data1,
              amount: parseFloat(auction?.auction?.pricePerCard).toFixed(2),
              gasPrice: web3.utils.toHex(gasPrice2),
              gasLimit: web3.utils.toHex(gasLimit2)
            }
            let parsedata2 = JSON.stringify(dataObj1)
            request({
              topic: connector?.topic,
              chainId: 'eip155:1',
              request: {
                id: 1,
                jsonrpc: '2.0',
                method: 'eth_signTransaction',
                params: [
                  {
                    to: onionContractAddress,
                    data: data1,
                    gasPrice: web3.utils.toHex(gasPrice2),
                    gasLimit: web3.utils.toHex(gasLimit2),
                    amount: parseFloat(auction?.auction?.pricePerCard).toFixed(
                      2
                    ),
                    symbol: auction.currency
                  }
                ]
              }
            })
              .then(response => {
                console.log("WC: Response 2:::::::",response)
                web3.eth
                  .sendSignedTransaction(response)
                  .on('transactionHash', data => {
                    buyNfts?.buyProduct(
                      {
                        ...savetransaction,
                        transaction: data,
                        status: 2
                      },
                      token,
                      (err, element) => { }
                    )
                  })
                  .once('receipt', hash => {
                    //console.log(hash)
                    console.log(hash)
                    callback(null, hash?.transactionHash)
                  })
                  .on('error', err => {
                    //console.log(err)
                    callback(err, null)
                  })
              })
              .catch(err => {
                console.log(err)
                callback(err, null)
              })
          })
          .catch(err => {
            console.log(err)
            callback(err, null)
          })
      })
      .catch(err => {
        console.log("err== in auctions", err)
        callback(err, null)
      })
  },
  async resellNfts(
    connector,
    account,
    auction,
    savetransaction,
    token,
    request,
    callback
  ) {
    // New Changes for walletconnect
    const currentNetwork =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYGON_RPCURL}`
          : `${process.env.REACT_APP_BINANCE_PROVIDER}`
        : `${process.env.REACT_APP_POLYGON_RPCURL}`
    const web3 = new Web3(currentNetwork)
    const addressFrom = account
    const addressTo = '0xb67C9263F86934461F9CB10468B72B15d9a9140A'
    const erc20ContractAddress =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? auction?.currency == 'EXS'
            ? `${process.env.REACT_APP_MUMBAI_ER20}`
            : `${process.env.REACT_APP_USDT_POLY}`
          : auction?.currency == 'EXS'
            ? `${process.env.REACT_APP_BINANCE_ER20}`
            : `${process.env.REACT_APP_USDT_BNB}`
        : auction?.currency == 'EXS'
          ? `${process.env.REACT_APP_MUMBAI_ER20}`
          : `${process.env.REACT_APP_USDT_POLY}`
    //console.log(erc20ContractAddress)
    const onionContractAddress =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_SELLING_POLY}`
          : `${process.env.REACT_APP_SELLING_BNB}`
        : `${process.env.REACT_APP_SELLING_POLY}`
    //console.log(onionContractAddress)
    const erc20Contract = new web3.eth.Contract(
      erc20['abi'],
      erc20ContractAddress
    )
    //console.log(erc20Contract)
    const contractAuction = new web3.eth.Contract(
      onion['abi'],
      onionContractAddress
    )
    //console.log(contractAuction)

    const chainId =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYID}`
          : `${process.env.REACT_APP_BINANCEID}`
        : `${process.env.REACT_APP_POLYID}`
    var zerosToAdd = '000000000000000000'
    var decimal = 18
    if (localStorage.getItem('currentNetwork') == 'MUMBAI') {
      zerosToAdd = auction?.currency == 'EXS' ? '000000000000000000' : '000000'
      decimal = auction?.currency == 'EXS' ? 18 : 6
    } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
      zerosToAdd = '000000000000000000'
      decimal = 18
    } else {
      zerosToAdd = auction?.currency == 'EXS' ? '000000000000000000' : '000000'
      decimal = auction?.currency == 'EXS' ? 18 : 6
    }
    const price = parseFloat(auction?.auction?.pricePerCard)
    const newPrice = ethers.utils.parseUnits(price + zerosToAdd, decimal)
    //console.log(auction?.auction?.pricePerCard)
    const gasPrice1 = await web3.eth.getGasPrice()
    const gasLimit1 = await erc20Contract.methods
      .approve(onionContractAddress, newPrice)
      .estimateGas({ from: account, gasPrice: gasPrice1 })
    let extraData = await erc20Contract.methods.approve(
      onionContractAddress,
      newPrice
    )
    //console.log(extraData)
    let data = extraData.encodeABI()
    const dataObj = {
      data: data,
      amount: parseFloat(auction?.auction?.pricePerCard),
      gasPrice: gasPrice1,
      gasLimit: gasLimit1
    }
    let parsedata1 = JSON.stringify(dataObj)
    //console.log(data)

    const customRequest = {
      id: 1337,
      jsonrpc: '2.0',
      method: 'bnb_sign',
      params: [
        {
          account_number: '34',
          chain_id: '97',
          data: parsedata1,
          memo: 'test',
          msgs: [
            {
              inputs: [
                {
                  address: erc20ContractAddress,
                  coins: [
                    {
                      amount: parseInt(auction?.auction?.pricePerCard),
                      denom: auction.currency
                    }
                  ]
                }
              ],
              outputs: [
                {
                  address: erc20ContractAddress,
                  coins: [
                    {
                      amount: parseInt(auction?.auction?.pricePerCard),
                      denom: auction.currency
                    }
                  ]
                }
              ]
            }
          ],
          sequence: '31',
          source: '1'
        }
      ]
    }
    request({
      topic: connector?.topic,
      chainId: 'eip155:1',
      request: {
        id: 1,
        jsonrpc: '2.0',
        method: 'eth_signTransaction',
        params: [
          {
            to: erc20ContractAddress,
            data: data,
            gasPrice: web3.utils.toHex(gasPrice1),
            gasLimit: web3.utils.toHex(gasLimit1),
            amount: parseFloat(auction?.auction?.pricePerCard).toFixed(2),
            symbol: auction.currency
          }
        ]
      }
    })
      .then(response => {
        web3.eth
          .sendSignedTransaction(response)
          .then(async data => {
            const gasPrice2 = await web3.eth.getGasPrice()
            const gasLimit2 = await contractAuction.methods
              .buyCard(auction?.auction.onionId, addressFrom)
              .estimateGas({ from: account, gasPrice: gasPrice1 })

            let extraData1 = await contractAuction.methods.buyCard(
              auction?.auction.onionId,
              addressFrom
            )
            //console.log(extraData1)
            let data1 = extraData1.encodeABI()

            request({
              topic: connector?.topic,
              chainId: 'eip155:1',
              request: {
                id: 1,
                jsonrpc: '2.0',
                method: 'eth_signTransaction',
                params: [
                  {
                    to: onionContractAddress,
                    data: data1,
                    gasPrice: web3.utils.toHex(gasPrice2),
                    gasLimit: web3.utils.toHex(gasLimit2),
                    amount: parseFloat(auction?.auction?.pricePerCard).toFixed(
                      2
                    ),
                    symbol: auction.currency
                  }
                ]
              }
            })
              .then(data => {
                web3.eth
                  .sendSignedTransaction(data)
                  .on('transactionHash', data => {
                    buyNfts?.buyProduct(
                      {
                        ...savetransaction,
                        transaction: data,
                        status: 2
                      },
                      token,
                      (err, element) => { }
                    )
                  })
                  .once('receipt', hash => {
                    //console.log(hash)
                    callback(null, hash?.transactionHash)
                  })
                  .on('error', err => {
                    //console.log(err)
                    callback(err, null)
                  })
              })
              .catch(err => {
                callback(err, null)
              })
          })
          .catch(err => {
            callback(err, null)
          })
      })
      .catch(err => {
        callback(err, null)
      })
    //console.log('I am Here')

    return
    connector
      .sendCustomRequest(customRequest)
      .then(async data => {
        //console.log(data)
        web3.eth
          .sendSignedTransaction(JSON.parse(data)?.signature)
          .then(async data => {
            //console.log(data)
            const gasPrice2 = await web3.eth.getGasPrice()
            const gasLimit2 = await contractAuction.methods
              .buyCard(auction?.auction.onionId, addressFrom)
              .estimateGas({ from: account, gasPrice: gasPrice1 })

            let extraData1 = await contractAuction.methods.buyCard(
              auction?.auction.onionId,
              addressFrom
            )
            //console.log(extraData1)
            let data1 = extraData1.encodeABI()
            const dataObj1 = {
              data: data1,
              amount: parseFloat(auction?.auction?.pricePerCard),
              gasPrice: gasPrice2,
              gasLimit: gasLimit2
            }
            let parsedata2 = JSON.stringify(dataObj1)
            //console.log(data1)
            setTimeout(() => {
              const customRequest1 = {
                id: 1337,
                jsonrpc: '2.0',
                method: 'bnb_sign',
                params: [
                  {
                    account_number: '34',
                    chain_id: '97',
                    data: parsedata2,
                    memo: 'test',
                    msgs: [
                      {
                        inputs: [
                          {
                            address: onionContractAddress,
                            coins: [
                              {
                                amount: parseInt(
                                  auction?.auction?.pricePerCard
                                ),
                                denom: auction.currency
                              }
                            ]
                          }
                        ],
                        outputs: [
                          {
                            address: onionContractAddress,
                            coins: [
                              {
                                amount: parseInt(
                                  auction?.auction?.pricePerCard
                                ),
                                denom: auction.currency
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    sequence: '31',
                    source: '1'
                  }
                ]
              }
              connector
                .sendCustomRequest(customRequest1)
                .then(data => {
                  //console.log(data)
                  web3.eth
                    .sendSignedTransaction(JSON.parse(data)?.signature)
                    .on('transactionHash', data => {
                      buyNfts?.buyProduct(
                        {
                          ...savetransaction,
                          transaction: data,
                          status: 2
                        },
                        token,
                        (err, element) => { }
                      )
                    })
                    .once('receipt', hash => {
                      //console.log(hash)
                      callback(null, hash?.transactionHash)
                    })
                    .on('error', err => {
                      //console.log(err)
                      callback(err, null)
                    })
                })
                .catch(err => {
                  //console.log(err)
                  callback(err, null)
                })
            }, 3000)
          })
          .catch(error => {
            //console.log(error)
            callback(error, null)
          })
      })
      .catch(err => {
        //console.log(err)
        callback(err, null)
      })
  },
  async sendTokenWithWalletConnect(
    provider,
    amount,
    account,
    address,
    tokenAddress,
    decimals,
    currentCurrency,
    amount1,
    callback
  ) {
    const currentNetwork =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_POLYGON_RPCURL}`
          : `${process.env.REACT_APP_BINANCE_PROVIDER}`
        : `${process.env.REACT_APP_POLYGON_RPCURL}`
    //console.log(currentNetwork)
    const web3 = new Web3(currentNetwork)
    const addressFrom = account
    const addressTo = address
    // const erc20ContractAddress = `${process.env.REACT_APP_BINANCE_ER20}`
    const erc20ContractAddress = tokenAddress
    // const onionContractAddress = `${process.env.REACT_APP_BINANCE_ONION}`
    const onionContractAddress =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? `${process.env.REACT_APP_MUMBAI_ONION}`
          : `${process.env.REACT_APP_BINANCE_ONION}`
        : `${process.env.REACT_APP_MUMBAI_ONION}`
    //console.log(currentNetwork)
    //console.log(tokenAddress)
    //console.log(onionContractAddress)
    const erc20Contract = new web3.eth.Contract(
      erc20['abi'],
      erc20ContractAddress
    )
    //console.log(erc20Contract)
    //console.log(erc20ContractAddress)
    const contractAuction = new web3.eth.Contract(
      onion['abi'],
      onionContractAddress
    )
    // alert(Number.isInteger(amount1))
    const gasPrice2 = await web3.eth.getGasPrice()
    const gasLimit2 = await erc20Contract.methods
      .transfer(address, ethers.utils.parseUnits(amount))
      .estimateGas({ from: account, gasPrice: gasPrice2 })
    let extraData = await erc20Contract.methods.transfer(
      address,
      ethers.utils.parseUnits(amount)
    )
    //console.log(ethers.utils.parseUnits(amount, decimals))
    let data = extraData.encodeABI()
    //console.log(data)
    let transferObject = {
      data: data,
      amount: parseFloat(amount1),
      gasPrice: gasPrice2,
      gasLimit: gasLimit2
    }
    let data1 = JSON.stringify(transferObject)
    //console.log(data1)
    try {
      const customRequest = {
        id: 1337,
        jsonrpc: '2.0',
        method: 'bnb_sign',
        params: [
          {
            account_number: '34',
            chain_id: '97',
            data: data1,
            memo: 'test',
            msgs: [
              {
                inputs: [
                  {
                    address: erc20ContractAddress,
                    coins: [
                      {
                        amount: 0,
                        denom: currentCurrency
                      }
                    ]
                  }
                ],
                outputs: [
                  {
                    address: erc20ContractAddress,
                    coins: [
                      {
                        amount: 0,
                        denom: currentCurrency
                      }
                    ]
                  }
                ]
              }
            ],
            sequence: '31',
            source: '1'
          }
        ]
      }
      provider
        .sendCustomRequest(customRequest)
        .then(async result => {
          //console.log(result)
          web3.eth
            .sendSignedTransaction(JSON.parse(result)?.signature)
            .once('receipt', hash => {
              //console.log(hash)
              callback(null, hash?.transactionHash)
            })
            .on('error', err => {
              callback(err, null)
            })
        })
        .catch(err => {
          //console.log(err)
          callback(err, null)
        })
    } catch (error) {
      //console.log(error)
      callback(error, null)
    }
  },
  async buyNft(account, library, auction, tokens, callback) {
    //console.log('Exs Ethereum Wallet Connection')
    //console.log(auction)
    // //console.log(account)
    // //console.log(library)
    // //console.log(!!account)
    // //console.log(!!library)
    var decimals = 18
    var price = auction?.auction?.pricePerCard
    //console.log(price)
    const web3 = new Web3(
      'https://ropsten.infura.io/v3/e7dc33febc3243498f44cae6cea0ba30'
    )
    var erc20Contract = tokens.find(
      x => x.name == auction.currency.toUpperCase()
    )
    //console.log(account)
    //console.log(erc20Contract)
    var count = await web3.eth.getTransactionCount(account)
    //console.log(count)
    var destAddress = '0xb67C9263F86934461F9CB10468B72B15d9a9140A'
    // var transferAmount = '100000000000000000000';
    var transferAmount = new BigNumber(price)
      .times(new BigNumber(10).pow(decimals))
      .toFixed()
    //console.log(transferAmount)
    // var contractAddress = "0xDD5CBBfb58B1463611433b12d256DC30AE24BF42";
    // var onionAdress = "0xC30aE6d7b2A7DfB7141A8ac3707dB34959f82F6f"
    // var contractAddress = `${process.env.REACT_APP_RINKEY_ER20}`
    var contractAddress = erc20Contract?.address
    var onionAdress = `${process.env.REACT_APP_RINKEY_ONION}`

    var contract = new web3.eth.Contract(erc20['abi'], contractAddress)
    //console.log(contract)
    const onionContract = new web3.eth.Contract(onion['abi'], onionAdress)
    //console.log(onionContract)
    var balance = await contract.methods.balanceOf(account).call()
    //console.log(balance / 10 ** 18)
    const gas = await contract.methods
      .approve(onionAdress, transferAmount)
      .estimateGas({ from: account })
    //console.log(gas)
    const allowed = await contract.methods
      .allowance(account, contractAddress)
      .call()

    //console.log(allowed)
    //console.log(balance / 10 ** 18)
    var gasPriceGwei = 3
    var gasLimit = 6000000
    var chainId = 1
    //console.log(web3.utils.toHex(2))
    const onionGas = await web3.eth.getGasPrice()
    const currency = auction.currency.toUpperCase() == 'EXS' ? '0x0' : '0x00'
    library
      .getSigner(account)
      .sendTransaction({
        to: contractAddress,
        // gasPrice: web3.utils.toHex(gasPriceGwei * 1e9),
        gasPrice: web3.utils.toHex(21000),
        // gas: web3.utils.toHex(gas),
        gasLimit: web3.utils.toHex(gasLimit),
        from: account,
        nonce: '0x' + count.toString(16),
        value: currency,
        data: contract.methods.approve(onionAdress, transferAmount).encodeABI()
      })
      .then(async signature => {
        //console.log(signature.hash) // todo remove dev item
        //console.log(signature)
        // setHash(signature.hash);
        // window.alert(`Success!\n\n${signature}`)
        const finalGas = blockLimit * gas
        const counter = count + 1
        //console.log(gas * 3000)
        //console.log(blockLimit)
        // const receipt = await this.getStatus(web3, signature?.hash);
        // //console.log(receipt)
        library
          .getSigner(account)
          .sendTransaction({
            to: onionAdress,
            gasPrice: web3.utils.toHex(onionGas),
            gasLimit: web3.utils.toHex(gasLimit),
            // gas: web3.utils.toHex(gas),
            from: account,
            nonce: '0x' + counter.toString(16),
            // value: web3.utils.toHex(transferAmount),
            value: currency,
            data: onionContract.methods
              .buyCard(auction?.auction.onionId, account)
              .encodeABI()
          })
          .then(signature => {
            callback(null, signature)
            //console.log(signature) // todo remove dev item
            // setHash(signature.hash);
            // window.alert(`Success!\n\n${signature}`)
          })
          .catch(error => {
            callback(error, null)
            // window.alert('Failure!' + (error && error.message ? `\n\n${error.message}` : ''))
          })
      })
      .catch(error => {
        callback(error, null)
        // window.alert('Failure!' + (error && error.message ? `\n\n${error.message}` : ''))
      })
    const latestblock = await web3.eth.getBlock('latest')
    const blockLimit = latestblock.gasLimit
  },
  async buyNftonSell(account, library, auction, tokens, callback) {
    var currentNetworkAddress = null
    var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
    if (currentnetwork == 'MUMBAI') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
    } else if (currentnetwork == 'BINANCE') {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
    } else {
      currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
    }

    var decimals = 18
    var price = auction?.auction?.pricePerCard
    //console.log(price)
    const web3 = new Web3(
      'https://ropsten.infura.io/v3/e7dc33febc3243498f44cae6cea0ba30'
    )
    var erc20Contract = tokens.find(
      x => x.name == auction.currency.toUpperCase()
    )
    //console.log(account)
    //console.log(erc20Contract)
    var count = await web3.eth.getTransactionCount(account)
    //console.log(count)
    var destAddress = '0xb67C9263F86934461F9CB10468B72B15d9a9140A'
    // var transferAmount = '100000000000000000000';
    var transferAmount = new BigNumber(price)
      .times(new BigNumber(10).pow(decimals))
      .toFixed()
    //console.log(transferAmount)
    var contractAddress = erc20Contract?.address
    var onionAdress = `${process.env.REACT_APP_RINKEY_ONION}`

    var contract = new web3.eth.Contract(erc20['abi'], contractAddress)
    //console.log(contract)
    const onionContract = new web3.eth.Contract(
      sell['abi'],
      currentNetworkAddress
    )
    //console.log(onionContract)
    var balance = await contract.methods.balanceOf(account).call()
    //console.log(balance / 10 ** 18)
    const gas = await contract.methods
      .approve(currentNetworkAddress, transferAmount)
      .estimateGas({ from: account })
    //console.log(gas)
    const allowed = await contract.methods
      .allowance(account, contractAddress)
      .call()

    //console.log(allowed)
    //console.log(balance / 10 ** 18)
    var gasPriceGwei = 3
    var gasLimit = 6000000
    var chainId = 1
    //console.log(web3.utils.toHex(2))
    const onionGas = await web3.eth.getGasPrice()
    const currency = auction.currency.toUpperCase() == 'EXS' ? '0x0' : '0x00'
    library
      .getSigner(account)
      .sendTransaction({
        to: contractAddress,
        // gasPrice: web3.utils.toHex(gasPriceGwei * 1e9),
        gasPrice: web3.utils.toHex(21000),
        // gas: web3.utils.toHex(gas),
        gasLimit: web3.utils.toHex(gasLimit),
        from: account,
        nonce: '0x' + count.toString(16),
        value: currency,
        data: contract.methods
          .approve(currentNetworkAddress, transferAmount)
          .encodeABI()
      })
      .then(async signature => {
        //console.log(signature.hash) // todo remove dev item
        //console.log(signature)
        // setHash(signature.hash);
        // window.alert(`Success!\n\n${signature}`)
        const finalGas = blockLimit * gas
        const counter = count + 1
        //console.log(gas * 3000)
        //console.log(blockLimit)
        // const receipt = await this.getStatus(web3, signature?.hash);
        // //console.log(receipt)
        library
          .getSigner(account)
          .sendTransaction({
            to: onionAdress,
            gasPrice: web3.utils.toHex(onionGas),
            gasLimit: web3.utils.toHex(gasLimit),
            // gas: web3.utils.toHex(gas),
            from: account,
            nonce: '0x' + counter.toString(16),
            // value: web3.utils.toHex(transferAmount),
            value: currency,
            data: onionContract.methods
              .buyCard(auction?.auction.onionId, account)
              .encodeABI()
          })
          .then(signature => {
            callback(null, signature)
            //console.log(signature) // todo remove dev item
            // setHash(signature.hash);
            // window.alert(`Success!\n\n${signature}`)
          })
          .catch(error => {
            callback(error, null)
            // window.alert('Failure!' + (error && error.message ? `\n\n${error.message}` : ''))
          })
      })
      .catch(error => {
        callback(error, null)
        // window.alert('Failure!' + (error && error.message ? `\n\n${error.message}` : ''))
      })
    const latestblock = await web3.eth.getBlock('latest')
    const blockLimit = latestblock.gasLimit
  },
  async buyAuction(
    Provider,
    address,
    auction,
    onionContract,
    tokens,
    dispatch,
    popup,
    processingLoader,
    transactiondata,
    token,
    callBack
  ) {
    try {
      // find the address contract using the name as reference
      var erc20Contract = tokens.find(
        x => x.name == auction.currency.toUpperCase()
      )
      var decimals = tokens.find(
        x => x.name == auction.currency.toUpperCase()
      )?.decimals
      //console.log(decimals)
      //console.log(erc20Contract)
      var gasPrice = await Provider.provider.request({
        method: 'eth_gasPrice',
        params: []
      })
      //console.log(gasPrice)
      gasPrice = Web3.utils.hexToNumberString(gasPrice)
      //console.log(gasPrice)
      // Contract calls to onionAuctions.sol
      const contractAuction = await this.providerRPC(
        Provider,
        onionContract.address,
        onion['abi']
      )
      //Contract calls to ERC20.sol
      const ERC20Contract = await this.providerRPC(
        Provider,
        erc20Contract.address,
        erc20['abi']
      )
      //console.log(ERC20Contract)
      var actualAuction = await this.auction(contractAuction, auction, tokens)
      if (
        actualAuction.pricePerCard <=
        parseFloat(auction.pricePerCard).toFixed(2)
      ) {
        // avoid race condition in the blockchain
        var amount = null
        if (currentNetwork == 'MUMBAI' && environement == 'live') {
          amount = this.fromDecimals(
            parseFloat(auction.pricePerCard).toFixed(5),
            erc20Contract
          )
        } else {
          amount = this.fromDecimals(
            parseFloat(auction.pricePerCard).toFixed(5) + 8,
            erc20Contract
          )
        }

        // var amount = this.fromDecimals(parseFloat(auction.pricePerCard).toFixed(2)+5, erc20Contract)
        // var amount = 0
        const gas = await ERC20Contract.methods
          .approve(onionContract.address, amount)
          .estimateGas({ from: address })
        //console.log(gas)
        // processingLoader(false)
        //allows the auction contract to manage user address funds.
        const allowed = await ERC20Contract.methods
          .allowance(address, onionContract.address)
          .call()
        popup.allowance = true //shows the user that he/she needs to approve funds to be spent on the contract.

        await ERC20Contract.methods
          .approve(onionContract.address, amount)
          .send({
            from: address,
            gas: gas,
            gasPrice: parseInt(gasPrice) * 4
          })
          .on('receipt', async function (hash) {
            var update = {
              //if the transaction is sent add tx to popup this does not mean that the transaction has been processed successfully.
              type: 'buyCard',
              key: 'approveTx',
              value: hash
            }
            //console.log(update)
            // await dispatch('notificationSystem/update', update, { root: true })
            await contractAuction.methods
              .buyCard(auction.onionId, address)
              .send({
                from: address,
                gas: gas * 10,
                gasPrice: parseInt(gasPrice) * 4
              })
              .on('transactionHash', data => {
                buyNfts?.buyProduct(
                  {
                    ...transactiondata,
                    transaction: data,
                    status: 2
                  },
                  token,
                  (err, element) => { }
                )
              })

              .on('receipt', async function (hash) {
                var update = {
                  type: 'buyCard',
                  key: 'purchaseTx',
                  value: hash?.transactionHash
                }
                //console.log(update)
                // await dispatch('notificationSystem/update', update, { root: true })
                callBack(update, null)
                return true
              })
              .on('error', async function (error) {
                if (
                  error?.message?.includes(
                    'Transaction has been reverted by the EVM'
                  )
                ) {
                  callBack(null, {
                    message: 'Transaction has been reverted by the EVM'
                  })
                } else {
                  callBack(null, error)
                }
              })

            // await dispatch('Wallet/updateBalancesERC1155', null, { root: true })
          })
        // }
        //  else {
        //     // await dispatch('notificationSystem/add', popup, { root: true })
        //     await contractAuction.methods.buyCard(auction.onionId, address).send({
        //         from: address,
        //         gas: gas * 10,
        //         gasPrice: parseInt(gasPrice) * 4
        //     })
        //         .on('transactionHash', (data) => {
        //             buyNfts?.buyProduct({
        //                 ...transactiondata,
        //                 transaction: data,
        //                 status: 0

        //             }, token, (err, element) => { })
        //         })
        //         .on('receipt', async function (hash) {
        //             var update = {
        //                 type: "buyCard",
        //                 key: "purchaseTx",
        //                 value: hash?.transactionHash
        //             }
        //             //console.log(update);
        //             // await dispatch('notificationSystem/update', update, { root: true })
        //             callBack(update, null)
        //             return true
        //         })

        //     // await dispatch('Wallet/updateBalancesERC1155', null, { root: true })
        // }
      } else {
        //if there is a race condition in the blockchain states warns the user that the auction data has changed.
        auction.pricePerCard = actualAuction.pricePerCard
        auction.nextPrice = actualAuction.nextPrice
        var data = {
          active: true,
          auction: auction
        }
        callBack(null, { message: 'Something Went wrong ' })
        //console.log(data)
        // dispatch("notificationSystem/addNewPrice", data, { root: true })
        // dispatch("Wallet/updateAuctions", null, { root: true })
      }
    } catch (error) {
      if (
        error?.message?.includes('Transaction has been reverted by the EVM')
      ) {
        callBack(null, { message: 'Transaction has been reverted by the EVM' })
      } else {
        callBack(null, error)
      }

      //console.log(error)
    }
  },
  async buyAuctionOnSell(
    Provider,
    address,
    auction,
    onionContract,
    tokens,
    dispatch,
    popup,
    processingLoader,
    transactiondata,
    token,
    callBack
  ) {
    try {
      // find the address contract using the name as reference
      var currentNetworkAddress = null
      var currentnetwork = localStorage.getItem('currentNetwork') || 'MUMBAI'
      if (currentnetwork == 'MUMBAI') {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_POLY}`
      } else if (currentnetwork == 'BINANCE') {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_BNB}`
      } else {
        currentNetworkAddress = `${process.env.REACT_APP_SELLING_ETH}`
      }
      var erc20Contract = tokens.find(
        x => x.name == auction.currency.toUpperCase()
      )
      var decimals = tokens.find(
        x => x.name == auction.currency.toUpperCase()
      )?.decimals
      //console.log(decimals)
      //console.log(erc20Contract)
      var gasPrice = await Provider.provider.request({
        method: 'eth_gasPrice',
        params: []
      })
      //console.log(gasPrice)
      gasPrice = Web3.utils.hexToNumberString(gasPrice)
      //console.log(gasPrice)
      // Contract calls to onionAuctions.sol
      const contractAuction = await this.providerRPC(
        Provider,
        currentNetworkAddress,
        sell['abi']
      )
      //Contract calls to ERC20.sol
      const ERC20Contract = await this.providerRPC(
        Provider,
        erc20Contract.address,
        erc20['abi']
      )
      //console.log(ERC20Contract)

      var actualAuction = await this.auction(contractAuction, auction, tokens)
      //console.log(actualAuction)
      if (
        actualAuction.pricePerCard <= parseFloat(auction.nftPrice).toFixed(2)
      ) {
        // avoid race condition in the blockchain
        var amount = this.fromDecimals(
          parseFloat(auction.nftPrice).toFixed(2) + 5,
          erc20Contract
        )
        // var amount = 0
        var gas = await ERC20Contract.methods
          .approve(currentNetworkAddress, amount)
          .estimateGas({ from: address })
        
        gas = Number(gas.toString())
        //console.log(gas)
        // processingLoader(false)
        //allows the auction contract to manage user address funds.
        const allowed = await ERC20Contract.methods
          .allowance(address, currentNetworkAddress)
          .call()
        //console.log(allowed)
        //console.log(amount)
        // if (allowed < amount) {
        popup.allowance = true //shows the user that he/she needs to approve funds to be spent on the contract.
        // await dispatch('notificationSystem/add', popup, { root: true })
        //console.log(onionContract.address)
        //console.log(typeof address)
        //console.log(typeof onionContract.address)
        await ERC20Contract.methods
          .approve(currentNetworkAddress, amount)
          .send({
            from: address,
            gas: gas,
            gasPrice: parseInt(gasPrice) * 4
          })
          .on('transactionHash', async function (hash) {
            var update = {
              //if the transaction is sent add tx to popup this does not mean that the transaction has been processed successfully.
              type: 'buyCard',
              key: 'approveTx',
              value: hash
            }
            //console.log(update)
            // await dispatch('notificationSystem/update', update, { root: true })
            await contractAuction.methods
              .buyCard(auction.onionId, address)
              .send({
                from: address,
                gas: gas * 10,
                gasPrice: parseInt(gasPrice) * 4
              })
              .on('transactionHash', data => {
                buyNfts?.buyProduct(
                  {
                    ...transactiondata,
                    transaction: data,
                    status: 2
                  },
                  token,
                  (err, element) => { }
                )
              })

              .on('receipt', async function (hash) {
                var update = {
                  type: 'buyCard',
                  key: 'purchaseTx',
                  value: hash?.transactionHash
                }
                //console.log(update)
                // await dispatch('notificationSystem/update', update, { root: true })
                callBack(update, null)
                return true
              })
              .on('error', async function (error) {
                if (
                  error?.message?.includes(
                    'Transaction has been reverted by the EVM'
                  )
                ) {
                  callBack(null, {
                    message: 'Transaction has been reverted by the EVM'
                  })
                } else {
                  callBack(null, error)
                }
              })
          })
      } else {
        //if there is a race condition in the blockchain states warns the user that the auction data has changed.
        auction.pricePerCard = actualAuction.pricePerCard
        auction.nextPrice = actualAuction.nextPrice
        var data = {
          active: true,
          auction: auction
        }
        callBack(null, { message: 'Something Went wrong ' })
        //console.log(data)
      }
    } catch (error) {
      if (
        error?.message?.includes('Transaction has been reverted by the EVM')
      ) {
        callBack(null, { message: 'Transaction has been reverted by the EVM' })
      } else {
        callBack(null, error)
      }

      //console.log(error)
    }
  },
  /**
   *
   * @param {Object} Provider wallet provider
   * @param {String} address user Address
   * @param {Object} auction Auction to buy
   * @param {Object} onionContract constant Data of the Onion contract
   * @param {Object} tokens cosntant to get data token
   * @param {Object} dispatch
   * @param {Object} popup state from 'notificationSystem' module
   * @returns {Boolean} if the transactions have been sent correctly, it returns true,
   * but this does not mean that the purchase has been successful,
   * since it is necessary to wait for the miners to validate the tx,
   *  and successfully add the tx's to the block.
   * you must have to weigh that the transaction appears as sent
   * but in the blockchain it is reversed or sent and validated correctly.
   */
  async buyAuctionWithWallet(
    Provider,
    address,
    auction,
    onionContract,
    tokens,
    dispatch,
    popup,
    processingLoader,
    callBack
  ) {
    var erc20Contract = tokens.find(
      x => x.name == auction.currency.toUpperCase()
    )
    const web3 = new Web3()
    web3.setProvider(
      new web3.providers.HttpProvider(
        'https://nd-054-081-873.p2pify.com/7945f2b3581521730210c5de131544ba'
      )
    )
    const contractAuction = new web3.eth.Contract(
      onion['abi'],
      onionContract.address
    )
    //console.log(contractAuction)
    var gasPrice = await Provider.provider.request({
      method: 'eth_gasPrice',
      params: []
    })
    //console.log(gasPrice)
    gasPrice = web3.utils.hexToNumberString(gasPrice)
    //console.log(gasPrice)
    const ERC20Contract1 = new web3.eth.Contract(
      erc20['abi'],
      erc20Contract.address
    )
    //console.log(ERC20Contract1)
    // const gas = await ERC20Contract1.methods.approve(onionContract.address, amount).estimateGas({ from: address })
    // //console.log(gas)
    var amount = this.fromDecimals(auction.pricePerCard, erc20Contract)
    const data1 = await ERC20Contract1.methods
      .approve(onionContract.address, 123)
      .encodeABI()
    //console.log(data1)
    const txObj = {
      from: address,
      to: onionContract.address,
      data: data1,
      value: '0',
      gas: web3.utils.toHex(124), // calculation of gas and gas Price is skipped here
      gasPrice: web3.utils.toHex(gasPrice),
      // privKey: adminPvtKey,
      nonce: web3.utils.toHex('0x23232333232')
    }
    //console.log(txObj)
    web3.eth.sendTransaction(txObj, function (error, result) {
      if (!error) {
        //console.log(result) //transaction successful
      } else {
        //console.log(error) //transaction failed
      }
    })
    return
  },

  callBack(err, result) {
    //console.log(err, result)

    return true
  }
}

export default Auction
